/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * PLCnext Store Frontend API
 * This is the PLCnext Store API used by the frontend.
 * OpenAPI spec version: v1
 */
export interface WebModelUpdateUser {
  /**
     * The phone number of the user
     * @minLength 0
     * @maxLength 25
     */
  phoneNumber?: string;
  /**
     * User first name
     * @minLength 0
     * @maxLength 50
     */
  firstName: string;
  /**
     * User last name
     * @minLength 0
     * @maxLength 50
     */
  lastName: string;
}

export interface WebModelGetAttachment {
  id?: number;
  locationUrl?: string;
  description?: string;
  checksum?: string;
  createdAt?: string;
}

export interface WebModelGetCompanyProfile {
  /** The automatic generated company profile ID */
  id?: number;
  /** The associated company ID */
  companyId: string;
  /** Logo url */
  logoUrl?: string;
  /** Banner url */
  bannerUrl?: string;
  /** Website url */
  websiteUrl?: string;
  /** The privacy policy file details */
  privacyPolicyFile?: WebModelGetAttachment;
  /** The public email address */
  email?: string;
  /** Long description */
  longDescription?: string;
  /** Short description */
  shortDescription?: string;
  /** Company name */
  companyName?: string;
  /** Legal notice */
  legalNotice?: string;
  /** Creation Date */
  createdAt?: string;
  /** Last Update Date */
  updatedAt?: string;
  /** Email address for credit notes */
  creditNoteEmailAddress?: string;
  /** Is credit note email address verified */
  isCreditNoteEmailAddressVerified?: boolean;
  /** Motivation of the developer to publish apps */
  motivation?: string;
}

export type WebModelPaymentProviderPaymentProviderType = typeof WebModelPaymentProviderPaymentProviderType[keyof typeof WebModelPaymentProviderPaymentProviderType];


export const WebModelPaymentProviderPaymentProviderType = {
  Novalnet: 'Novalnet',
  Stripe: 'Stripe',
} as const;

export interface WebModelPaymentProvider {
  id?: number;
  paymentProviderType?: WebModelPaymentProviderPaymentProviderType;
}

export interface WebModelGetHub {
  name?: string;
  currency?: string;
  currencyShortAfter?: string;
  currencyShortBefore?: string;
  minPrice?: number;
  developerCountries?: string[];
  companyHasReleasedApps?: boolean;
  paymentProvider?: WebModelPaymentProvider;
}

export interface WebModelGetCompany {
  /** The automatic generated company ID (read-only) */
  id: string;
  /**
     * Company name
     * @minLength 0
     * @maxLength 100
     */
  name: string;
  /**
     * VAT id number
     * @minLength 0
     * @maxLength 20
     */
  vatIdNumber?: string;
  /** Id of the legal address */
  legalAddressId?: number;
  /** Was store admin notified that company data were completed (read-only) */
  storeAdminNotified: boolean;
  /** Company active or not */
  active: boolean;
  /** Creation date (read-only) */
  createdAt?: string;
  /** PhoenixContact company flag (read-only) */
  phoenix?: boolean;
  /** Is the company approved or not. (read-only) */
  approvedContributor?: boolean;
  /** The ebilling email address for a company(read-only) */
  ebillingAddress?: string;
  /** The contributor company profile */
  companyProfile?: WebModelGetCompanyProfile;
  /** The company has at least one released app */
  hasReleasedApp?: boolean;
  /** The list of hubs where the company offers apps */
  hubs?: WebModelGetHub[];
  /** The pxc customer number */
  pxcNumber?: string;
  /** is the pxc customer number verified */
  pxcNumberVerified?: boolean;
  ebillingAddressVerified?: boolean;
}

export type WebModelGetCountryStatus = typeof WebModelGetCountryStatus[keyof typeof WebModelGetCountryStatus];


export const WebModelGetCountryStatus = {
  Full: 'Full',
  Restricted: 'Restricted',
  Forbidden: 'Forbidden',
} as const;

export interface WebModelGetCountry {
  iso?: string;
  status?: WebModelGetCountryStatus;
  hub?: WebModelGetHub;
  phoenixSapSales?: boolean;
}

export interface WebModelGetUser {
  uuid?: string;
  userName?: string;
  mfaEnabled?: boolean;
  phoneNumber?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  hub?: WebModelGetHub;
  company?: WebModelGetCompany;
  country?: WebModelGetCountry;
  roles?: string[];
  companyId?: string;
}

export interface WebModelUpdateUserPassword {
  password?: string;
  currentPassword?: string;
}

export interface WebModelUpdateUserEmail {
  email?: string;
  password?: string;
}

export interface WebModelGetCertificate {
  createdAt?: string;
  updatedAt?: string;
  id?: number;
  serialNumberAsHex?: string;
  notValidBefore?: string;
  notValidAfter?: string;
  earliestUpdateDate?: string;
  revoked?: boolean;
  userUuid?: string;
  userName?: string;
  userFirstName?: string;
  userLastName?: string;
  certAsPem?: string;
}

export interface WebModelPutUserAccessToken {
  description?: string;
  expirationDate?: string;
}

export interface WebModelGetUserAccessToken {
  expirationDate?: string;
  description?: string;
  id?: number;
}

export interface Role {
  id: number;
  name: string;
  description?: string;
  mfaRequired?: boolean;
}

export interface WebModelPutUpdateHardwareType {
  /** The automatic generated HardwareType ID (read-only) */
  id?: number;
  /**
     * The name of the hardware target
     * @minLength 0
     * @maxLength 30
     */
  targetType: string;
  title?: string;
  url?: string;
  manufacturer?: string;
}

export interface WebModelGetHardwareType {
  id?: number;
  targetType?: string;
  title?: string;
  url?: string;
  manufacturer?: string;
}

/**
 * The json to update the device
 */
export interface WebModelPutUpdateDevice {
  /**
     * The unique device id provided by PhoenixContact
     * @minLength 0
     * @maxLength 40
     */
  deviceId: string;
  /** The name of device */
  name: string;
  /**
     * The icon url of the device
     * @minLength 0
     * @maxLength 255
     */
  iconUrl?: string;
  /**
     * The description of the device
     * @minLength 0
     * @maxLength 100
     */
  description?: string;
  /** Indicates if the icon has changed */
  iconHasChanged?: boolean;
}

export type WebModelGetDeviceDeviceType = typeof WebModelGetDeviceDeviceType[keyof typeof WebModelGetDeviceDeviceType];


export const WebModelGetDeviceDeviceType = {
  PLCNEXT: 'PLCNEXT',
  HOST: 'HOST',
} as const;

export interface WebModelGetDevice {
  deviceId?: string;
  userUuid?: string;
  ownerEmail?: string;
  name?: string;
  iconUrl?: string;
  description?: string;
  online?: boolean;
  firmwareVersion?: string;
  articleName?: string;
  status?: number;
  sdCardSupported?: boolean;
  sdCardInserted?: boolean;
  sdCardHwUuid?: string;
  sdCardType?: string;
  overlayFSType?: string;
  deviceType?: WebModelGetDeviceDeviceType;
  wibuHostName?: string;
  lastSeen?: string;
}

export type WebModelPutConfigVarVarName = typeof WebModelPutConfigVarVarName[keyof typeof WebModelPutConfigVarVarName];


export const WebModelPutConfigVarVarName = {
  NotifyAdminForNewContributorEmailAddress: 'NotifyAdminForNewContributorEmailAddress',
  NotifyAdminForAppHarmfulBehaviorEmailAddress: 'NotifyAdminForAppHarmfulBehaviorEmailAddress',
  ReportIllegalContentEmailAddress: 'ReportIllegalContentEmailAddress',
  BCCEmailAddressesForInvoicesEU: 'BCCEmailAddressesForInvoicesEU',
  BCCEmailAddressesForInvoicesUS: 'BCCEmailAddressesForInvoicesUS',
  BCCEmailAddressesForCreditNotesEU: 'BCCEmailAddressesForCreditNotesEU',
  BCCEmailAddressesForCreditNotesUS: 'BCCEmailAddressesForCreditNotesUS',
  EmailAddressesForAppReleaseNotification: 'EmailAddressesForAppReleaseNotification',
  NotifyAdminForNewPxCNumberSpecifiedEmailAddress: 'NotifyAdminForNewPxCNumberSpecifiedEmailAddress',
  MaintenanceBannerText: 'MaintenanceBannerText',
  DsaReportActivUsersText: 'DsaReportActivUsersText',
  EmailFooterText: 'EmailFooterText',
  LicenseCertifacteTemplate: 'LicenseCertifacteTemplate',
  EmailAddressesForHandleOrderPayedFailed: 'EmailAddressesForHandleOrderPayedFailed',
  EmailAddressForSupportEmails: 'EmailAddressForSupportEmails',
} as const;

export type WebModelPutConfigVarVarValue = { [key: string]: unknown };

export interface WebModelPutConfigVar {
  varName?: WebModelPutConfigVarVarName;
  varValue?: WebModelPutConfigVarVarValue;
}

export type WebModelGetConfigVarVarName = typeof WebModelGetConfigVarVarName[keyof typeof WebModelGetConfigVarVarName];


export const WebModelGetConfigVarVarName = {
  NotifyAdminForNewContributorEmailAddress: 'NotifyAdminForNewContributorEmailAddress',
  NotifyAdminForAppHarmfulBehaviorEmailAddress: 'NotifyAdminForAppHarmfulBehaviorEmailAddress',
  ReportIllegalContentEmailAddress: 'ReportIllegalContentEmailAddress',
  BCCEmailAddressesForInvoicesEU: 'BCCEmailAddressesForInvoicesEU',
  BCCEmailAddressesForInvoicesUS: 'BCCEmailAddressesForInvoicesUS',
  BCCEmailAddressesForCreditNotesEU: 'BCCEmailAddressesForCreditNotesEU',
  BCCEmailAddressesForCreditNotesUS: 'BCCEmailAddressesForCreditNotesUS',
  EmailAddressesForAppReleaseNotification: 'EmailAddressesForAppReleaseNotification',
  NotifyAdminForNewPxCNumberSpecifiedEmailAddress: 'NotifyAdminForNewPxCNumberSpecifiedEmailAddress',
  MaintenanceBannerText: 'MaintenanceBannerText',
  DsaReportActivUsersText: 'DsaReportActivUsersText',
  EmailFooterText: 'EmailFooterText',
  LicenseCertifacteTemplate: 'LicenseCertifacteTemplate',
  EmailAddressesForHandleOrderPayedFailed: 'EmailAddressesForHandleOrderPayedFailed',
  EmailAddressForSupportEmails: 'EmailAddressForSupportEmails',
} as const;

export type WebModelGetConfigVarVarValue = { [key: string]: unknown };

export type WebModelGetConfigVarVarType = typeof WebModelGetConfigVarVarType[keyof typeof WebModelGetConfigVarVarType];


export const WebModelGetConfigVarVarType = {
  String: 'String',
  Long: 'Long',
  JSON: 'JSON',
  Template: 'Template',
} as const;

export interface WebModelGetConfigVar {
  varName?: WebModelGetConfigVarVarName;
  varValue?: WebModelGetConfigVarVarValue;
  varType?: WebModelGetConfigVarVarType;
}

/**
 * The json to update the profile
 */
export interface WebModelPutUpdateCompanyProfile {
  /** The automatic generated company profile ID */
  id: number;
  /**
     * The associated company ID
     * @deprecated
     */
  companyId: string;
  /**
     * Website url
     * @minLength 0
     * @maxLength 255
     */
  websiteUrl?: string;
  /**
     * The public email address
     * @minLength 0
     * @maxLength 50
     */
  email?: string;
  /**
     * Long description
     * @minLength 0
     * @maxLength 4000
     */
  longDescription?: string;
  /**
     * Short description
     * @minLength 0
     * @maxLength 500
     */
  shortDescription?: string;
  /**
     * Legal notice
     * @minLength 0
     * @maxLength 1000
     */
  legalNotice?: string;
  /** Should the old privacy policy file be deleted. (needed to differentiate between deleted and no (new) updated) */
  privacyPolicyFileDeleted?: boolean;
  /** Motivation of the developer to publish apps */
  motivation?: string;
}

export interface WebModelPutUpdateAddress {
  /** The iso6339_alpha2 country code of the address */
  country: string;
  /**
     * The state of the address
     * @minLength 0
     * @maxLength 30
     */
  state?: string;
  /** The city of the address */
  city: string;
  /** The postal code of the address */
  postalCode: string;
  /** The street of the address */
  street: string;
  /**
     * The house number of the address
     * @minLength 0
     * @maxLength 10
     */
  houseNumber?: string;
  /** Additional address info */
  additionalInfo?: string;
}

export interface WebModelPutUpdateCompany {
  /** The automatic generated company ID (read-only) */
  id: string;
  /**
     * Company name
     * @minLength 0
     * @maxLength 100
     */
  name: string;
  /**
     * VAT id number
     * @minLength 0
     * @maxLength 20
     */
  vatIdNumber?: string;
  /** Company active or not */
  active: boolean;
  /** Indicates whether the company's legal address should be updated */
  updateLegalAddress: boolean;
  /** The pxc customer number */
  pxcNumber?: string;
  legalAddress?: WebModelPutUpdateAddress;
}

export interface WebModelPutUpdateCompanyMember {
  admin?: boolean;
}

export interface WebModelPutCategoryGroup {
  name?: string;
}

export interface WebModelGetCategoryGroup {
  id?: number;
  name?: string;
}

export interface WebModelPutCategorie {
  name?: string;
  categoryGroupId?: number;
}

export interface WebModelGetCategory {
  id?: number;
  name?: string;
  categoryGroup?: WebModelGetCategoryGroup;
}

export interface WebModelPutAppSettingsAsAdmin {
  externalFee?: boolean;
  externalInstallLink?: string;
  categoryIds?: number[];
  licenseVariantsAllowed?: boolean;
  multiLicenseVariantSelection?: boolean;
  licenseBundleAllowed?: boolean;
  safety?: boolean;
}

export type WebModelGetAppLicenseOptionPriceInHub = {[key: string]: number};

export type WebModelGetAppLicenseOptionReleaseStatus = typeof WebModelGetAppLicenseOptionReleaseStatus[keyof typeof WebModelGetAppLicenseOptionReleaseStatus];


export const WebModelGetAppLicenseOptionReleaseStatus = {
  RELEASED: 'RELEASED',
  DRAFT: 'DRAFT',
} as const;

export interface WebModelGetAppLicenseOption {
  id?: number;
  productCode?: number;
  firmCode?: number;
  sapNo?: string;
  name?: string;
  appId?: number;
  appIconUrl?: string;
  appName?: string;
  appTypeName?: string;
  priceInHub?: WebModelGetAppLicenseOptionPriceInHub;
  itemIdFull?: string;
  itemIdTrial?: string;
  bundleComponents?: unknown[];
  releaseStatus?: WebModelGetAppLicenseOptionReleaseStatus;
  displayOrder?: number;
  hasTrial?: boolean;
}

export type WebModelGetAppSettingsAppStatus = typeof WebModelGetAppSettingsAppStatus[keyof typeof WebModelGetAppSettingsAppStatus];


export const WebModelGetAppSettingsAppStatus = {
  UNPUBLISHED: 'UNPUBLISHED',
  PUBLISHED: 'PUBLISHED',
  DISCONTINUED: 'DISCONTINUED',
  ARCHIVED: 'ARCHIVED',
} as const;

export interface WebModelGetAppType {
  id?: number;
  name?: string;
  hasPlcInstallation?: boolean;
  plcLicensable?: boolean;
  hasDownload?: boolean;
  helpText?: string;
  productcodesFromStoreRange?: boolean;
  analyseJsonFile?: boolean;
  acceptedFileFormat?: string;
  engineerLibrary?: boolean;
  engineerPlugin?: boolean;
}

export interface WebModelGetAppSettings {
  appId?: number;
  firmCode?: number;
  productCode?: number;
  externalInstallLink?: string;
  supportMailAddress?: string;
  supportMailTags?: string;
  externalFee?: boolean;
  licenseVariantsAllowed?: boolean;
  multiLicenseVariantSelection?: boolean;
  licenseBundleAllowed?: boolean;
  appType?: WebModelGetAppType;
  categoryIds?: number[];
  categories?: WebModelGetCategory[];
  licenseOptions?: WebModelGetAppLicenseOption[];
  hubNames?: string[];
  iconUrl?: string;
  companyId?: string;
  companyName?: string;
  name?: string;
  appStatus?: WebModelGetAppSettingsAppStatus;
  safety?: boolean;
}

export interface WebModelGetHardwareRecommendation {
  orderId?: number;
  description?: string;
  locationUrl?: string;
}

export interface WebModelGetTechnicalDetail {
  attributeName?: string;
  attributeValue?: string;
}

export interface WebModelPutAppVersionData {
  description?: string;
  whatsNew?: string;
  version?: string;
  hardwareRecommendations?: WebModelGetHardwareRecommendation[];
  technicalDetailList?: WebModelGetTechnicalDetail[];
  changelogFileDeleted?: boolean;
  deletedAppBinaryIds?: number[];
  deletedTechnicalDocumentFileIds?: number[];
  deletedMediaFileIds?: number[];
  maxFirmwareVersionId?: number;
}

export interface WebModelGetAppBinaryAppInfo {
  minEngineerVersion?: string;
  autoupdateEnabled?: boolean;
  autoupdateKeepTempData?: boolean;
  autoupdateKeepPersistentData?: boolean;
}

export interface WebModelGetAppBinary {
  id?: number;
  locationUrl?: string;
  description?: string;
  checksum?: string;
  createdAt?: string;
  signedByDeveloper?: boolean;
  signedByStore?: boolean;
  hardwareTargets?: WebModelGetHardwareType[];
  appInfo?: WebModelGetAppBinaryAppInfo;
}

export type WebModelGetAppVersionAppVersionStatus = typeof WebModelGetAppVersionAppVersionStatus[keyof typeof WebModelGetAppVersionAppVersionStatus];


export const WebModelGetAppVersionAppVersionStatus = {
  DRAFT: 'DRAFT',
  RELEASED: 'RELEASED',
  DEACTIVATED: 'DEACTIVATED',
} as const;

export type WebModelGetAppVersionLicenseType = typeof WebModelGetAppVersionLicenseType[keyof typeof WebModelGetAppVersionLicenseType];


export const WebModelGetAppVersionLicenseType = {
  FREE: 'FREE',
  LIMITED: 'LIMITED',
  FULL: 'FULL',
} as const;

export interface WebModelGetAppVersion {
  id?: number;
  appId?: number;
  description?: string;
  whatsNew?: string;
  appSettings?: WebModelGetAppSettings;
  status?: number;
  appVersionStatus?: WebModelGetAppVersionAppVersionStatus;
  version?: string;
  internalVersion?: number;
  lastUpdate?: string;
  releaseDate?: string;
  createdAt?: string;
  updatedAt?: string;
  endOfLifeDate?: string;
  certified?: boolean;
  downloads?: number;
  minFirmwareVersion?: string;
  maxFirmwareVersionId?: number;
  licenseType?: WebModelGetAppVersionLicenseType;
  deactivated?: boolean;
  hardwareRecommendations?: WebModelGetHardwareRecommendation[];
  installations?: number;
  technicalDetailList?: WebModelGetTechnicalDetail[];
  appBinaries?: WebModelGetAppBinary[];
  changeLog?: WebModelGetAttachment;
  technicalDocuments?: WebModelGetAttachment[];
  media?: WebModelGetAttachment[];
  attachments?: WebModelGetAttachment[];
}

export type WebModelPutUpdateAppStatusAppVersionStatus = typeof WebModelPutUpdateAppStatusAppVersionStatus[keyof typeof WebModelPutUpdateAppStatusAppVersionStatus];


export const WebModelPutUpdateAppStatusAppVersionStatus = {
  DRAFT: 'DRAFT',
  RELEASED: 'RELEASED',
  DEACTIVATED: 'DEACTIVATED',
} as const;

export type WebModelPutUpdateAppStatusAppStatus = typeof WebModelPutUpdateAppStatusAppStatus[keyof typeof WebModelPutUpdateAppStatusAppStatus];


export const WebModelPutUpdateAppStatusAppStatus = {
  UNPUBLISHED: 'UNPUBLISHED',
  PUBLISHED: 'PUBLISHED',
  DISCONTINUED: 'DISCONTINUED',
  ARCHIVED: 'ARCHIVED',
} as const;

export interface WebModelPutUpdateAppStatus {
  appVersionStatus?: WebModelPutUpdateAppStatusAppVersionStatus;
  appStatus?: WebModelPutUpdateAppStatusAppStatus;
}

export interface WebModelPutAppCoreData {
  appName?: string;
  supportMailAddress?: string;
  supportMailTags?: string;
  hubNames?: string[];
  categoryIds?: number[];
}

export type WebModelPutLicenseOptionPrices = {[key: string]: number};

export interface WebModelPutLicenseOption {
  name?: string;
  prices?: WebModelPutLicenseOptionPrices;
  sapNo?: string;
  licenseBundeLicenseOptionIds?: number[];
  displayOrder?: number;
}

export type WebModelPutLicenseOptionStatusStatus = typeof WebModelPutLicenseOptionStatusStatus[keyof typeof WebModelPutLicenseOptionStatusStatus];


export const WebModelPutLicenseOptionStatusStatus = {
  RELEASED: 'RELEASED',
  DRAFT: 'DRAFT',
} as const;

export interface WebModelPutLicenseOptionStatus {
  status?: WebModelPutLicenseOptionStatusStatus;
}

export interface WebModelPutAppType {
  helpText?: string;
}

export interface CmContainerContextFile {
  cmContainerContextFile?: string;
}

export interface WebModelUpdateUserCountry {
  iso?: string;
}

export interface WebModelPasswordReset {
  email?: string;
}

export interface WebModelPasswordResetConfirm {
  token?: string;
  newPassword?: string;
  email?: string;
}

export interface WebModelCreateUser {
  email: string;
  password: string;
  /**
     * @minLength 3
     * @maxLength 25
     */
  username: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  inviteCode?: string;
  becomeDeveloper?: boolean;
  iso?: string;
}

export type FieldErrorRejectedValue = { [key: string]: unknown };

export interface FieldError {
  field?: string;
  error?: string;
  rejectedValue?: FieldErrorRejectedValue;
}

export type StoreApiErrorStatus = typeof StoreApiErrorStatus[keyof typeof StoreApiErrorStatus];


export const StoreApiErrorStatus = {
  '100_CONTINUE': '100 CONTINUE',
  '101_SWITCHING_PROTOCOLS': '101 SWITCHING_PROTOCOLS',
  '102_PROCESSING': '102 PROCESSING',
  '103_EARLY_HINTS': '103 EARLY_HINTS',
  '103_CHECKPOINT': '103 CHECKPOINT',
  '200_OK': '200 OK',
  '201_CREATED': '201 CREATED',
  '202_ACCEPTED': '202 ACCEPTED',
  '203_NON_AUTHORITATIVE_INFORMATION': '203 NON_AUTHORITATIVE_INFORMATION',
  '204_NO_CONTENT': '204 NO_CONTENT',
  '205_RESET_CONTENT': '205 RESET_CONTENT',
  '206_PARTIAL_CONTENT': '206 PARTIAL_CONTENT',
  '207_MULTI_STATUS': '207 MULTI_STATUS',
  '208_ALREADY_REPORTED': '208 ALREADY_REPORTED',
  '226_IM_USED': '226 IM_USED',
  '300_MULTIPLE_CHOICES': '300 MULTIPLE_CHOICES',
  '301_MOVED_PERMANENTLY': '301 MOVED_PERMANENTLY',
  '302_FOUND': '302 FOUND',
  '302_MOVED_TEMPORARILY': '302 MOVED_TEMPORARILY',
  '303_SEE_OTHER': '303 SEE_OTHER',
  '304_NOT_MODIFIED': '304 NOT_MODIFIED',
  '305_USE_PROXY': '305 USE_PROXY',
  '307_TEMPORARY_REDIRECT': '307 TEMPORARY_REDIRECT',
  '308_PERMANENT_REDIRECT': '308 PERMANENT_REDIRECT',
  '400_BAD_REQUEST': '400 BAD_REQUEST',
  '401_UNAUTHORIZED': '401 UNAUTHORIZED',
  '402_PAYMENT_REQUIRED': '402 PAYMENT_REQUIRED',
  '403_FORBIDDEN': '403 FORBIDDEN',
  '404_NOT_FOUND': '404 NOT_FOUND',
  '405_METHOD_NOT_ALLOWED': '405 METHOD_NOT_ALLOWED',
  '406_NOT_ACCEPTABLE': '406 NOT_ACCEPTABLE',
  '407_PROXY_AUTHENTICATION_REQUIRED': '407 PROXY_AUTHENTICATION_REQUIRED',
  '408_REQUEST_TIMEOUT': '408 REQUEST_TIMEOUT',
  '409_CONFLICT': '409 CONFLICT',
  '410_GONE': '410 GONE',
  '411_LENGTH_REQUIRED': '411 LENGTH_REQUIRED',
  '412_PRECONDITION_FAILED': '412 PRECONDITION_FAILED',
  '413_PAYLOAD_TOO_LARGE': '413 PAYLOAD_TOO_LARGE',
  '413_REQUEST_ENTITY_TOO_LARGE': '413 REQUEST_ENTITY_TOO_LARGE',
  '414_URI_TOO_LONG': '414 URI_TOO_LONG',
  '414_REQUEST_URI_TOO_LONG': '414 REQUEST_URI_TOO_LONG',
  '415_UNSUPPORTED_MEDIA_TYPE': '415 UNSUPPORTED_MEDIA_TYPE',
  '416_REQUESTED_RANGE_NOT_SATISFIABLE': '416 REQUESTED_RANGE_NOT_SATISFIABLE',
  '417_EXPECTATION_FAILED': '417 EXPECTATION_FAILED',
  '418_I_AM_A_TEAPOT': '418 I_AM_A_TEAPOT',
  '419_INSUFFICIENT_SPACE_ON_RESOURCE': '419 INSUFFICIENT_SPACE_ON_RESOURCE',
  '420_METHOD_FAILURE': '420 METHOD_FAILURE',
  '421_DESTINATION_LOCKED': '421 DESTINATION_LOCKED',
  '422_UNPROCESSABLE_ENTITY': '422 UNPROCESSABLE_ENTITY',
  '423_LOCKED': '423 LOCKED',
  '424_FAILED_DEPENDENCY': '424 FAILED_DEPENDENCY',
  '425_TOO_EARLY': '425 TOO_EARLY',
  '426_UPGRADE_REQUIRED': '426 UPGRADE_REQUIRED',
  '428_PRECONDITION_REQUIRED': '428 PRECONDITION_REQUIRED',
  '429_TOO_MANY_REQUESTS': '429 TOO_MANY_REQUESTS',
  '431_REQUEST_HEADER_FIELDS_TOO_LARGE': '431 REQUEST_HEADER_FIELDS_TOO_LARGE',
  '451_UNAVAILABLE_FOR_LEGAL_REASONS': '451 UNAVAILABLE_FOR_LEGAL_REASONS',
  '500_INTERNAL_SERVER_ERROR': '500 INTERNAL_SERVER_ERROR',
  '501_NOT_IMPLEMENTED': '501 NOT_IMPLEMENTED',
  '502_BAD_GATEWAY': '502 BAD_GATEWAY',
  '503_SERVICE_UNAVAILABLE': '503 SERVICE_UNAVAILABLE',
  '504_GATEWAY_TIMEOUT': '504 GATEWAY_TIMEOUT',
  '505_HTTP_VERSION_NOT_SUPPORTED': '505 HTTP_VERSION_NOT_SUPPORTED',
  '506_VARIANT_ALSO_NEGOTIATES': '506 VARIANT_ALSO_NEGOTIATES',
  '507_INSUFFICIENT_STORAGE': '507 INSUFFICIENT_STORAGE',
  '508_LOOP_DETECTED': '508 LOOP_DETECTED',
  '509_BANDWIDTH_LIMIT_EXCEEDED': '509 BANDWIDTH_LIMIT_EXCEEDED',
  '510_NOT_EXTENDED': '510 NOT_EXTENDED',
  '511_NETWORK_AUTHENTICATION_REQUIRED': '511 NETWORK_AUTHENTICATION_REQUIRED',
} as const;

export interface StoreApiError {
  status?: StoreApiErrorStatus;
  message?: string;
  errors?: string[];
  fieldErrors?: FieldError[];
  errorId?: string;
  error?: string;
}

export interface WebModelConfirmUser {
  base64Token: string;
}

export interface WebModelMfaResetByRecoveryCodeRequest {
  email: string;
  password: string;
  recoveryCode: string;
}

export interface WebModelMfaResetByRecoveryCodeResponse {
  webModelGetUser?: WebModelGetUser;
  deactivated?: boolean;
}

export interface WebModelMfaDeactivationRequest {
  userUuid: string;
  authCode: string;
}

export interface WebModelMfaDeactivationResponse {
  webModelGetUser?: WebModelGetUser;
  deactivated?: boolean;
}

export interface WebModelMfaConfirmRequest {
  userUuid: string;
  authCode: string;
}

export interface WebModelMfaConfirmResponse {
  webModelGetUser?: WebModelGetUser;
  recoveryCode?: string;
}

export interface WebModelMfaActivationRequest {
  userId: string;
  password: string;
}

export interface WebModelMfaActivationResponse {
  secret?: string;
  issuer?: string;
  hashingAlgorithm?: string;
  accountName?: string;
  digits?: number;
  period?: number;
  totpLink?: string;
  qrCode?: string;
}

export interface WebModelPostNewUserAccessToken {
  description?: string;
  expirationDate?: string;
}

export interface PaymentRegisterRequest {
  /** The order id */
  orderId: number;
}

export type WebModelPaymentAccountAccountStatus = typeof WebModelPaymentAccountAccountStatus[keyof typeof WebModelPaymentAccountAccountStatus];


export const WebModelPaymentAccountAccountStatus = {
  NOT_STARTED: 'NOT_STARTED',
  PROCESSING: 'PROCESSING',
  DOCUMENTS_COMPLETE: 'DOCUMENTS_COMPLETE',
  ACTIVE: 'ACTIVE',
  DECLINED: 'DECLINED',
  TERMINATED: 'TERMINATED',
  INFORMATION_MISSING: 'INFORMATION_MISSING',
} as const;

export interface WebModelPaymentAccount {
  paymentProvider?: WebModelPaymentProvider;
  hub?: WebModelGetHub;
  accountStatus?: WebModelPaymentAccountAccountStatus;
  merchantAccountId?: string;
  merchantId?: string;
  stripeAccountId?: string;
}

export interface AmountAndClientCount {
  amount?: number;
  clientCount?: number;
}

export type WebModelCreateOrderLicenseOptionIdAndQuantityMap = {[key: string]: AmountAndClientCount};

export interface WebModelCreateOrder {
  hubName: string;
  customReference?: string;
  licenseOptionIdAndQuantityMap: WebModelCreateOrderLicenseOptionIdAndQuantityMap;
  buyerUuid: string;
}

export type WebModelGetOrderStatus = typeof WebModelGetOrderStatus[keyof typeof WebModelGetOrderStatus];


export const WebModelGetOrderStatus = {
  STARTED: 'STARTED',
  OK: 'OK',
  CANCELED: 'CANCELED',
} as const;

export interface WebModelGetOrder {
  id?: number;
  orderDate?: string;
  status?: WebModelGetOrderStatus;
  totalPrice?: number;
  novalnetTransactionId?: string;
  novalnetErrorCode?: string;
  createdAt?: string;
  updatedAt?: string;
  orderNumber?: number;
  userUuid?: string;
  userName?: string;
  userEmail?: string;
  invoiceFileName?: string;
  creditNoteFileName?: string;
}

export interface WebModelPostEmailToAllUsers {
  subject?: string;
  message?: string;
}

/**
 * The support message parameters as json
 */
export interface WebModelPostSupportMessage {
  firstName?: string;
  lastName?: string;
  email?: string;
  companyName?: string;
  deviceId?: string;
  deviceHw?: string;
  deviceFw?: string;
  message?: string;
  sendCopy?: boolean;
  captcha?: string;
}

export interface WebModelPostIllegalContentReport {
  nameOfLegalEntity?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  affectedContent?: string;
  justification?: string;
}

export interface WebModelPostMessage {
  message?: string;
  sendCopy?: boolean;
  captcha?: string;
}

export type WebModelPostReportAppReportAppReason = typeof WebModelPostReportAppReportAppReason[keyof typeof WebModelPostReportAppReportAppReason];


export const WebModelPostReportAppReportAppReason = {
  SENDS_DATA_HOME: 'SENDS_DATA_HOME',
  MANIPULATES_SPS: 'MANIPULATES_SPS',
  OTHER: 'OTHER',
} as const;

export interface WebModelPostReportApp {
  message?: string;
  sendCopy?: boolean;
  captcha?: string;
  reportAppReason?: WebModelPostReportAppReportAppReason;
}

export interface WebModelUserLogin {
  username?: string;
  password?: string;
  captcha?: string;
  authCode?: string;
  developerRequest?: boolean;
  requestMfaDeviceToken?: boolean;
}

export interface WebModelCreateReportJSError {
  error?: string;
  stack?: string;
}

export interface WebModelPostNewHardwareType {
  /**
     * The name of the hardware target
     * @minLength 0
     * @maxLength 30
     */
  targetType: string;
  title?: string;
  url?: string;
  manufacturer?: string;
}

export interface WebModelPostMajorMinorFirmwareVersion {
  major?: number;
  minor?: number;
}

export interface WebModelGetMajorMinorFirmwareVersion {
  major?: number;
  minor?: number;
  createdAt?: string;
  updatedAt?: string;
  id?: number;
}

/**
 * The json to add the device
 */
export interface WebModelPostNewDevice {
  /**
     * The unique device id provided by PhoenixContact, in case a hardware PLC is added.
     * @minLength 0
     * @maxLength 40
     */
  deviceId?: string;
  /**
     * Assigned user
     * @minLength 0
     * @maxLength 40
     */
  userUuid: string;
  /** The name of device */
  name: string;
  /**
     * The description of the device
     * @minLength 0
     * @maxLength 100
     */
  description?: string;
  /** Add the device as public (available for company) or private device */
  isPublic: boolean;
}

export interface DeviceDetails {
  articleName?: string;
  firmwareVersion?: string;
  onlineStatus?: boolean;
  currentConnectionDuration?: number;
  lastOnlineDate?: string;
  sdCardSupported?: boolean;
  sdCardInserted?: boolean;
  sdCardHwUuid?: string;
  sdCardType?: string;
  overlayFSType?: string;
  sdCardCmSerialId?: string;
  deviceCmSerialId?: string;
  major?: number;
  minor?: number;
  patch?: number;
}

export interface WebModelPostCompanyProfile {
  /** The associated company ID */
  companyId: string;
  /**
     * The public email address
     * @minLength 0
     * @maxLength 50
     */
  email?: string;
}

export interface WebModelCreditNoteEmailAddress {
  email: string;
}

export interface WebModelCreditNoteEmailAddressVerify {
  code?: string;
}

export interface WebModelPostAdminNote {
  adminNote?: string;
}

export interface WebModelPostNewAddress {
  /** The iso6339_alpha2 country code of the address */
  country: string;
  /**
     * The state of the address
     * @minLength 0
     * @maxLength 30
     */
  state?: string;
  /** The city of the address */
  city: string;
  /** The postal code of the address */
  postalCode: string;
  /** The street of the address */
  street: string;
  /**
     * The house number of the address
     * @minLength 0
     * @maxLength 10
     */
  houseNumber?: string;
  /** Additional address info */
  additionalInfo?: string;
}

export interface WebModelPostCompany {
  /**
     * Company name
     * @minLength 0
     * @maxLength 100
     */
  name: string;
  /**
     * VAT id number
     * @minLength 0
     * @maxLength 20
     */
  vatIdNumber?: string;
  /** The pxc customer number */
  pxcNumber?: string;
  webModelUpdateUser?: WebModelUpdateUser;
  webModelPostNewAddress?: WebModelPostNewAddress;
}

export interface WebModelPostPxCNumberAdminNote {
  pxcNumberNote?: string;
}

export interface WebModelEBillingAddress {
  ebillingEmail?: string;
}

export interface WebModelEBillingAddressVerify {
  code?: string;
}

export interface WebModelPostCompanyInvite {
  inviteeEmail?: string;
  inviteeFirstName?: string;
  inviteeLastName?: string;
  message?: string;
}

export interface WebModelGetCompanyInvite {
  code?: string;
  inviteeEmail?: string;
  inviteeEmailRegistered?: boolean;
  inviteeFirstname?: string;
  inviteeLastname?: string;
  message?: string;
  companyId?: string;
  invitingUserUuid?: string;
  createdAt?: string;
  inviteeName?: string;
  codeExpired?: boolean;
  link?: string;
  invitingUserEmail?: string;
  companyName?: string;
}

export interface WebModelPostCategoryGroup {
  name?: string;
}

export interface WebModelPostCategory {
  name?: string;
  categoryGroupId?: number;
}

export interface WebModelPostNewAppAsAdminLicenseOption {
  productCode?: string;
  itemId?: string;
  licenseOptionName?: string;
}

export interface WebModelPostNewAppAsAdmin {
  userName?: string;
  appName?: string;
  appProductCode?: string;
  licenseOptions?: WebModelPostNewAppAsAdminLicenseOption[];
}

export interface WebModelPostNewRelease {
  /** Internal Version number for filtering */
  internalVersion: number;
}

export interface WebModelPostAppBinary {
  hardwareTargetIds?: number[];
}

export interface WebModelPostNewTrialCode {
  days?: number;
  note?: string;
}

export interface WebModelGetTrialCode {
  code?: string;
  alreadyUsed?: boolean;
  days?: number;
  createdAt?: string;
  note?: string;
  licenseOptionId?: number;
  appId?: number;
}

/**
 * Status of the license
 */
export type WebModelGetAppLicenseStatus = typeof WebModelGetAppLicenseStatus[keyof typeof WebModelGetAppLicenseStatus];


export const WebModelGetAppLicenseStatus = {
  UNINSTALLED: 'UNINSTALLED',
  INSTALL_REQUESTED: 'INSTALL_REQUESTED',
  INSTALLING_RAC_REQUESTED: 'INSTALLING_RAC_REQUESTED',
  INSTALLING_RAC_RECEIVED: 'INSTALLING_RAC_RECEIVED',
  INSTALLING_RAC_DELIVERED: 'INSTALLING_RAC_DELIVERED',
  INSTALLING_RAU_REQUESTED: 'INSTALLING_RAU_REQUESTED',
  INSTALLING_RAU_RECEIVED: 'INSTALLING_RAU_RECEIVED',
  DELIVERED: 'DELIVERED',
  INSTALLING_RAU_DELIVERED: 'INSTALLING_RAU_DELIVERED',
  INSTALLING_RAR_REQUESTED: 'INSTALLING_RAR_REQUESTED',
  INSTALLING_RAR_RECEIVED: 'INSTALLING_RAR_RECEIVED',
  INSTALLING_RAR_DELIVERED: 'INSTALLING_RAR_DELIVERED',
  INSTALLED: 'INSTALLED',
  UNINSTALL_REQUESTED: 'UNINSTALL_REQUESTED',
  UNINSTALLING_RAC_REQUESTED: 'UNINSTALLING_RAC_REQUESTED',
  UNINSTALLING_RAC_RECEIVED: 'UNINSTALLING_RAC_RECEIVED',
  UNINSTALLING_RAC_DELIVERED: 'UNINSTALLING_RAC_DELIVERED',
  UNINSTALLING_RAU_REQUESTED: 'UNINSTALLING_RAU_REQUESTED',
  RETURN_DELIVERED: 'RETURN_DELIVERED',
  UNINSTALLING_RAU_RECEIVED: 'UNINSTALLING_RAU_RECEIVED',
  UNINSTALLING_RAU_DELIVERED: 'UNINSTALLING_RAU_DELIVERED',
  UNINSTALLING_RAR_REQUESTED: 'UNINSTALLING_RAR_REQUESTED',
  UNINSTALLING_RAR_RECEIVED: 'UNINSTALLING_RAR_RECEIVED',
  UNINSTALLING_RAR_DELIVERED: 'UNINSTALLING_RAR_DELIVERED',
} as const;

/**
 * Type of the license an enum string
 */
export type WebModelGetAppLicenseLicenseType = typeof WebModelGetAppLicenseLicenseType[keyof typeof WebModelGetAppLicenseLicenseType];


export const WebModelGetAppLicenseLicenseType = {
  PAID: 'PAID',
  TRIAL: 'TRIAL',
  FREE: 'FREE',
} as const;

export interface WebModelGetAppLicense {
  /** The automatic generated application license ID */
  id?: number;
  /** The automatic generated installed app id ID */
  installedAppId?: number;
  /** Application id */
  appId: number;
  /** Owner of the license */
  userUuid: string;
  /** Device uuid where application is installed */
  deviceId?: string;
  /** Version of related app in use */
  version: string;
  /** Status of the license */
  status: WebModelGetAppLicenseStatus;
  /** Creation date */
  createdAt?: string;
  /** Type of the license (0 = Trial, 1 = Paid) */
  type: number;
  /** Type of the license an enum string */
  licenseType?: WebModelGetAppLicenseLicenseType;
  /** License ticket id (used by Wibu license manager) */
  ticketId?: string;
  /** Name of the application */
  appName?: string;
  /** The icon URL of the application */
  appIconUrl?: string;
  /** The status of the application. 0 - Draft, 1 - Released, 2 - Archived. */
  appStatus?: number;
  /** Is autoupdate enabled (from latest released version of this app) */
  autoupdateEnabled?: boolean;
  /** autoupdate keep temp data (from latest released version of this app) */
  autoupdateKeepTempData?: boolean;
  /** autoupdate keep persistent data (from latest released version of this app) */
  autoupdateKeepPersistentData?: boolean;
  /** Is an update available for the associated application */
  updateAvailable?: boolean;
  /** AppSettings of the related app version */
  appSettings?: WebModelGetAppSettings;
  /** License Option web model */
  licenseOption?: WebModelGetAppLicenseOption;
  ownerEmail?: string;
  clientCount?: number;
  partOfMultiLicenseTicket?: boolean;
}

/**
 * The model containing information which license options to link to the host device.
 */
export interface WebModelPostLinkLicensesToHostDevice {
  deviceId?: string;
  licenseIds?: number[];
}

export type WebModelPostInstallAppAndLicensesAppLicenseType = typeof WebModelPostInstallAppAndLicensesAppLicenseType[keyof typeof WebModelPostInstallAppAndLicensesAppLicenseType];


export const WebModelPostInstallAppAndLicensesAppLicenseType = {
  PAID: 'PAID',
  TRIAL: 'TRIAL',
  FREE: 'FREE',
} as const;

/**
 * The model containing information on what to install. If no appVersionId is given only licenses will be installed.
 */
export interface WebModelPostInstallAppAndLicenses {
  deviceId?: string;
  installOnSdCard?: boolean;
  appLicenseType?: WebModelPostInstallAppAndLicensesAppLicenseType;
  licenseOptionIds?: number[];
  licenseIds?: number[];
  appVersionId?: number;
  trialCode?: string;
}

export interface WebModelReactivation {
  success?: boolean;
  ticketids?: string[];
}

export interface WebModelGetLicenseImportResult {
  ticketIdsWithErrors?: string[];
  importedLicenses?: WebModelGetAppLicense[];
}

export interface CmContainerUpdateFile {
  cmContainerUpdateFile?: string;
}

export interface WebModelGetUserAppSubscription {
  appName?: string;
  appId?: number;
  appIconUrl?: string;
  appType?: string;
  userEncrypted?: string;
  updateNotifications?: boolean;
  safetyNotifications?: boolean;
  safetyApp?: boolean;
}

export interface PublicUser {
  /** The unique id provided by ProfiCloud (read-only) */
  uuid: string;
  /** Email address (managed by ProfiCloud; read-only) */
  email: string;
  /** User first name */
  firstName?: string;
  /** User last name */
  lastName?: string;
  /** The users company id */
  companyId?: string;
}

export interface WebModelMfaResetRequestCodeInfoResponse {
  email?: string;
  unknownUser?: boolean;
  unknownCode?: boolean;
  expired?: boolean;
}

export interface WebModelMfaDeviceTokenInfoResponse {
  username?: string;
  uuid?: string;
}

export interface WebModelGetUserWithIdmInfos {
  uuid?: string;
  userName?: string;
  mfaEnabled?: boolean;
  phoneNumber?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  hub?: WebModelGetHub;
  company?: WebModelGetCompany;
  country?: WebModelGetCountry;
  roles?: string[];
  companyId?: string;
  deleted?: boolean;
  verified?: boolean;
}

export interface WebModelCountryAndHubForUser {
  hub?: WebModelGetHub;
  isoCountryCode?: string;
  country?: WebModelGetCountry;
  userUuid?: string;
}

export type WebModelGetAppStatus = typeof WebModelGetAppStatus[keyof typeof WebModelGetAppStatus];


export const WebModelGetAppStatus = {
  IDLE: 'IDLE',
  PREPARING: 'PREPARING',
  WAITING_FOR_DEVICE: 'WAITING_FOR_DEVICE',
  DOWNLOADING: 'DOWNLOADING',
  UPDATE_LICENSE: 'UPDATE_LICENSE',
  INSTALLING: 'INSTALLING',
  ACTIVATING: 'ACTIVATING',
  INSTALLED: 'INSTALLED',
  UNINSTALLING: 'UNINSTALLING',
  DEACTIVATING: 'DEACTIVATING',
  UNINSTALLED: 'UNINSTALLED',
} as const;

export type WebModelGetAppAppStatus = typeof WebModelGetAppAppStatus[keyof typeof WebModelGetAppAppStatus];


export const WebModelGetAppAppStatus = {
  INSTALLED: 'INSTALLED',
  UNINSTALLED: 'UNINSTALLED',
  RUNNING: 'RUNNING',
} as const;

export type WebModelGetAppActivationStatus = typeof WebModelGetAppActivationStatus[keyof typeof WebModelGetAppActivationStatus];


export const WebModelGetAppActivationStatus = {
  UNKNOWN: 'UNKNOWN',
  RUNNING: 'RUNNING',
  START_REQUESTED: 'START_REQUESTED',
  STARTING: 'STARTING',
  STOPPED: 'STOPPED',
  STOP_REQUESTED: 'STOP_REQUESTED',
  STOPPING: 'STOPPING',
} as const;

export type WebModelGetAppLicenseType = typeof WebModelGetAppLicenseType[keyof typeof WebModelGetAppLicenseType];


export const WebModelGetAppLicenseType = {
  PAID: 'PAID',
  TRIAL: 'TRIAL',
  FREE: 'FREE',
} as const;

export interface WebModelGetApp {
  appLicenseId?: number;
  name?: string;
  appId?: number;
  id?: number;
  installedAppId?: number;
  version?: string;
  versionMinFirmware?: string;
  versionMaxFirmware?: string;
  proficloudAppId?: string;
  iconUrl?: string;
  percentFinished?: number;
  status?: WebModelGetAppStatus;
  appStatus?: WebModelGetAppAppStatus;
  activationStatus?: WebModelGetAppActivationStatus;
  licenseType?: WebModelGetAppLicenseType;
  errorCode?: string;
  errorMsg?: string;
  price?: number;
  autoupdateEnabled?: boolean;
  autoupdateKeepTempData?: boolean;
  autoupdateKeepPersistentData?: boolean;
  updateAvailable?: boolean;
  newVersion?: string;
  newVersionMinFirmware?: string;
  newVersionMaxFirmware?: string;
  cmActId?: string;
  appSettings?: WebModelGetAppSettings;
}

export type WebModelGetLicenseStatus = typeof WebModelGetLicenseStatus[keyof typeof WebModelGetLicenseStatus];


export const WebModelGetLicenseStatus = {
  UNINSTALLED: 'UNINSTALLED',
  INSTALL_REQUESTED: 'INSTALL_REQUESTED',
  INSTALLING_RAC_REQUESTED: 'INSTALLING_RAC_REQUESTED',
  INSTALLING_RAC_RECEIVED: 'INSTALLING_RAC_RECEIVED',
  INSTALLING_RAC_DELIVERED: 'INSTALLING_RAC_DELIVERED',
  INSTALLING_RAU_REQUESTED: 'INSTALLING_RAU_REQUESTED',
  INSTALLING_RAU_RECEIVED: 'INSTALLING_RAU_RECEIVED',
  DELIVERED: 'DELIVERED',
  INSTALLING_RAU_DELIVERED: 'INSTALLING_RAU_DELIVERED',
  INSTALLING_RAR_REQUESTED: 'INSTALLING_RAR_REQUESTED',
  INSTALLING_RAR_RECEIVED: 'INSTALLING_RAR_RECEIVED',
  INSTALLING_RAR_DELIVERED: 'INSTALLING_RAR_DELIVERED',
  INSTALLED: 'INSTALLED',
  UNINSTALL_REQUESTED: 'UNINSTALL_REQUESTED',
  UNINSTALLING_RAC_REQUESTED: 'UNINSTALLING_RAC_REQUESTED',
  UNINSTALLING_RAC_RECEIVED: 'UNINSTALLING_RAC_RECEIVED',
  UNINSTALLING_RAC_DELIVERED: 'UNINSTALLING_RAC_DELIVERED',
  UNINSTALLING_RAU_REQUESTED: 'UNINSTALLING_RAU_REQUESTED',
  RETURN_DELIVERED: 'RETURN_DELIVERED',
  UNINSTALLING_RAU_RECEIVED: 'UNINSTALLING_RAU_RECEIVED',
  UNINSTALLING_RAU_DELIVERED: 'UNINSTALLING_RAU_DELIVERED',
  UNINSTALLING_RAR_REQUESTED: 'UNINSTALLING_RAR_REQUESTED',
  UNINSTALLING_RAR_RECEIVED: 'UNINSTALLING_RAR_RECEIVED',
  UNINSTALLING_RAR_DELIVERED: 'UNINSTALLING_RAR_DELIVERED',
} as const;

export interface WebModelGetLicense {
  id?: number;
  status?: WebModelGetLicenseStatus;
  errorCode?: string;
  errorMsg?: string;
  ticketId?: string;
  proficloudAppId?: string;
  appSettings?: WebModelGetAppSettings;
  licenseOption?: WebModelGetAppLicenseOption;
  appName?: string;
  idOfApp?: number;
  appId?: number;
  licenseType?: string;
  cmActId?: string;
  clientCount?: number;
  partOfMultiLicenseTicket?: boolean;
}

export type WebModelSelectableDeviceDeviceType = typeof WebModelSelectableDeviceDeviceType[keyof typeof WebModelSelectableDeviceDeviceType];


export const WebModelSelectableDeviceDeviceType = {
  PLCNEXT: 'PLCNEXT',
  HOST: 'HOST',
} as const;

export interface WebModelSelectableDevice {
  deviceId?: string;
  name?: string;
  description?: string;
  iconUrl?: string;
  firmware?: string;
  hardware?: string;
  online?: boolean;
  sdCardSupported?: boolean;
  sdCardInserted?: boolean;
  sdCardType?: string;
  appList?: WebModelGetApp[];
  licenseList?: WebModelGetLicense[];
  overlayFSType?: string;
  createdAt?: string;
  lastSeen?: string;
  deviceType?: WebModelSelectableDeviceDeviceType;
  wibuHostName?: string;
  userHasAlreadyInstalledTrial?: boolean;
}

export interface WebModelGetExtendedTrialCode {
  trialCode?: WebModelGetTrialCode;
  appVersion?: WebModelGetAppVersion;
  selectableDevices?: WebModelSelectableDevice[];
}

export type WebModelGetRequstedActionRequestMethod = typeof WebModelGetRequstedActionRequestMethod[keyof typeof WebModelGetRequstedActionRequestMethod];


export const WebModelGetRequstedActionRequestMethod = {
  installApp: 'installApp',
  uninstallApp: 'uninstallApp',
  getAppStatus: 'getAppStatus',
  installPlcNextLib: 'installPlcNextLib',
  uninstallPlcNextLib: 'uninstallPlcNextLib',
  getPlcNextLibStatus: 'getPlcNextLibStatus',
  getFirmwareVersion: 'getFirmwareVersion',
  activateApp: 'activateApp',
  getLicenseStatus: 'getLicenseStatus',
  installLicense: 'installLicense',
  uninstallLicense: 'uninstallLicense',
  updateLicense: 'updateLicense',
  getlicensecontainer: 'getlicensecontainer',
  getsdslotstatus: 'getsdslotstatus',
  getAppChunk: 'getAppChunk',
  licenseInit: 'licenseInit',
  licenseActivate: 'licenseActivate',
  licenseDeactivate: 'licenseDeactivate',
  licenseConfirm: 'licenseConfirm',
  appStatus: 'appStatus',
  licenseStatus: 'licenseStatus',
  firmwareVersion: 'firmwareVersion',
  licenseContainer: 'licenseContainer',
  sdSlotStatus: 'sdSlotStatus',
} as const;

export interface WebModelGetRequstedAction {
  taskId?: string;
  deviceId?: string;
  requestMethod?: WebModelGetRequstedActionRequestMethod;
  completedAt?: string;
}

export type WebModelGetLicenseContainerTypeType = typeof WebModelGetLicenseContainerTypeType[keyof typeof WebModelGetLicenseContainerTypeType];


export const WebModelGetLicenseContainerTypeType = {
  DEVICE: 'DEVICE',
  SDCARD: 'SDCARD',
} as const;

export interface WebModelGetLicenseContainerType {
  id?: number;
  cmActId?: string;
  firmCode?: number;
  name?: string;
  type?: WebModelGetLicenseContainerTypeType;
}

export interface WebModelGetDownloadChart {
  id?: number;
  appId?: number;
  rank?: number;
  downloads?: number;
}

export interface WebModelGetKPI {
  date?: string;
  registeredUsers?: number;
  registeredDevices?: number;
  paidLicenses?: number;
  trialLicenses?: number;
  boundPaidLicenses?: number;
  unboundPaidLicenses?: number;
  releasedSoftwareArtefacts?: number;
  draftedSoftwareArtefacts?: number;
  archivedSoftwareArtefacts?: number;
  totalLibraryDownloads?: number;
  totalAppDownloads?: number;
  totalDownloads?: number;
  downloadCharts?: WebModelGetDownloadChart[];
}

export interface WebModelKnowledgeBaseDocument {
  html?: string;
  title?: string;
}

export interface IJournalEvent {
  bundleKey?: string;
  journalText?: string;
}

export interface WebModelGetJournal {
  event?: IJournalEvent;
  journalText?: string;
  journalContextName?: string;
  journalContextId?: string;
  uuid?: string;
  timestamp?: string;
}

export interface WebModelGenericEnum {
  id?: string;
  name?: string;
}

export interface WebModelGetJournalCount {
  entryCount?: number;
}

export interface HardwareType {
  id?: number;
  /**
     * @minLength 0
     * @maxLength 30
     */
  targetType: string;
  title?: string;
  url?: string;
  manufacturer?: string;
}

export interface WebModelGetLicenseContainer {
  cmSerialId?: string;
  hwUuid?: string;
  deviceUuid?: string;
  licenseContainerType?: WebModelGetLicenseContainerType;
  updatedAt?: string;
}

export interface WebModelGetDeviceCounts {
  myDevicesCount?: number;
  companyDevicesCount?: number;
  memberDevicesCount?: number;
}

export type WebModelGetDeviceWithAppsAndLicensesDeviceType = typeof WebModelGetDeviceWithAppsAndLicensesDeviceType[keyof typeof WebModelGetDeviceWithAppsAndLicensesDeviceType];


export const WebModelGetDeviceWithAppsAndLicensesDeviceType = {
  PLCNEXT: 'PLCNEXT',
  HOST: 'HOST',
} as const;

export interface WebModelGetDeviceWithAppsAndLicenses {
  deviceId?: string;
  name?: string;
  description?: string;
  iconUrl?: string;
  firmware?: string;
  hardware?: string;
  online?: boolean;
  sdCardSupported?: boolean;
  sdCardInserted?: boolean;
  sdCardType?: string;
  appList?: WebModelGetApp[];
  licenseList?: WebModelGetLicense[];
  overlayFSType?: string;
  createdAt?: string;
  lastSeen?: string;
  deviceType?: WebModelGetDeviceWithAppsAndLicensesDeviceType;
  wibuHostName?: string;
}

export interface KeyValue {
  key: string;
  value: string;
}

export interface DeploymentInfo {
  idmUrlExternal?: string;
  version?: string;
  buildNumber?: string;
  sessionTimeoutInMs?: number;
  frontendLogoutWarningTimeInMs?: number;
  friendlyCaptchaPuzzleEndpoint?: string;
  friendlyCaptchaSitekey?: string;
  friendlyCaptchaEnabled?: boolean;
  festoHwPrefix?: string;
  codeMeterRuntimeEnableFwPrefix?: string;
  maxSupportAttachmentSizeInBytes?: number;
  mfaDeviceTokenCookieValidityInDays?: number;
}

export interface WebModelGetCompanyMember {
  firstName?: string;
  lastName?: string;
  name?: string;
  email?: string;
  createdAt?: string;
  userUuid?: string;
  certificateIds?: string[];
  certificates?: WebModelGetCertificate[];
  admin?: boolean;
}

export interface WebModelGetCompanyForAdminView {
  /** The automatic generated company ID (read-only) */
  id: string;
  /**
     * Company name
     * @minLength 0
     * @maxLength 100
     */
  name: string;
  /**
     * VAT id number
     * @minLength 0
     * @maxLength 20
     */
  vatIdNumber?: string;
  /** Id of the legal address */
  legalAddressId?: number;
  /** Was store admin notified that company data were completed (read-only) */
  storeAdminNotified: boolean;
  /** Company active or not */
  active: boolean;
  /** Creation date (read-only) */
  createdAt?: string;
  /** PhoenixContact company flag (read-only) */
  phoenix?: boolean;
  /** Is the company approved or not. (read-only) */
  approvedContributor?: boolean;
  /** The ebilling email address for a company(read-only) */
  ebillingAddress?: string;
  /** The contributor company profile */
  companyProfile?: WebModelGetCompanyProfile;
  /** The company has at least one released app */
  hasReleasedApp?: boolean;
  /** The list of hubs where the company offers apps */
  hubs?: WebModelGetHub[];
  /** The pxc customer number */
  pxcNumber?: string;
  /** is the pxc customer number verified */
  pxcNumberVerified?: boolean;
  adminPhoneNumber?: string;
  adminNote?: string;
  pxcNumberNote?: string;
  adminFirstName?: string;
  adminLastName?: string;
  adminEMail?: string;
  ebillingAddressVerified?: boolean;
}

export type WebModelGetDeveloperAppAppStatus = typeof WebModelGetDeveloperAppAppStatus[keyof typeof WebModelGetDeveloperAppAppStatus];


export const WebModelGetDeveloperAppAppStatus = {
  UNPUBLISHED: 'UNPUBLISHED',
  PUBLISHED: 'PUBLISHED',
  DISCONTINUED: 'DISCONTINUED',
  ARCHIVED: 'ARCHIVED',
} as const;

export interface WebModelGetDeveloperApp {
  appId?: number;
  name?: string;
  iconUrl?: string;
  createdAt?: string;
  updatedAt?: string;
  appInfoJsonProficloudAppId?: string;
  versions?: WebModelGetAppVersion[];
  appType?: WebModelGetAppType;
  appStatus?: WebModelGetDeveloperAppAppStatus;
  favorite?: boolean;
}

export interface WebModelAppPageAndContent {
  content?: WebModelGetAppVersion[];
  totalElements?: number;
  totalPages?: number;
  number?: number;
  size?: number;
}

export interface WebModelGetIsAppReleaseable {
  alreadyReleased?: boolean;
  iconMissing?: boolean;
  binaryMissing?: boolean;
  noHubActivated?: boolean;
  descriptionEmpty?: boolean;
  whatsNewEmpty?: boolean;
  storePricesInconsistent?: boolean;
  setNoLicenseOptionReleased?: boolean;
  supportMailAddressEmpty?: boolean;
  allowedTargetEmpty?: boolean;
  releaseable?: boolean;
}

export type InstallationDetailStatusStatus = typeof InstallationDetailStatusStatus[keyof typeof InstallationDetailStatusStatus];


export const InstallationDetailStatusStatus = {
  IDLE: 'IDLE',
  PREPARING: 'PREPARING',
  WAITING_FOR_DEVICE: 'WAITING_FOR_DEVICE',
  DOWNLOADING: 'DOWNLOADING',
  UPDATE_LICENSE: 'UPDATE_LICENSE',
  INSTALLING: 'INSTALLING',
  ACTIVATING: 'ACTIVATING',
  INSTALLED: 'INSTALLED',
  UNINSTALLING: 'UNINSTALLING',
  DEACTIVATING: 'DEACTIVATING',
  UNINSTALLED: 'UNINSTALLED',
} as const;

export type InstallationDetailStatusAppStatus = typeof InstallationDetailStatusAppStatus[keyof typeof InstallationDetailStatusAppStatus];


export const InstallationDetailStatusAppStatus = {
  INSTALLED: 'INSTALLED',
  UNINSTALLED: 'UNINSTALLED',
  RUNNING: 'RUNNING',
} as const;

export type InstallationDetailStatusActivationStatus = typeof InstallationDetailStatusActivationStatus[keyof typeof InstallationDetailStatusActivationStatus];


export const InstallationDetailStatusActivationStatus = {
  UNKNOWN: 'UNKNOWN',
  RUNNING: 'RUNNING',
  START_REQUESTED: 'START_REQUESTED',
  STARTING: 'STARTING',
  STOPPED: 'STOPPED',
  STOP_REQUESTED: 'STOP_REQUESTED',
  STOPPING: 'STOPPING',
} as const;

export interface InstallationDetailStatus {
  appId?: string;
  percentFinished?: number;
  status?: InstallationDetailStatusStatus;
  statusText?: string;
  licenseId?: number;
  appStatus?: InstallationDetailStatusAppStatus;
  activationStatus?: InstallationDetailStatusActivationStatus;
  errorMsg?: string;
  errorCode?: string;
  installedAppId?: number;
  proficloudAppId?: string;
  appName?: string;
  licenseOptionName?: string;
}

export type WebModelAdminErrorInfoType = typeof WebModelAdminErrorInfoType[keyof typeof WebModelAdminErrorInfoType];


export const WebModelAdminErrorInfoType = {
  LICENSE: 'LICENSE',
  LIBRARY: 'LIBRARY',
  APP: 'APP',
} as const;

export interface WebModelAdminErrorInfo {
  type?: WebModelAdminErrorInfoType;
  installedAppId?: number;
  licenseId?: number;
  applianceId?: string;
  ticketId?: string;
  errorCode?: string;
  errorMsg?: string;
  state?: string;
  cmActId?: string;
  itemId?: string;
  productCode?: string;
  firmCode?: string;
  createdAt?: string;
  updatedAt?: string;
  userUuid?: string;
  userName?: string;
  userEmail?: string;
  deviceArticleName?: string;
  deviceFirmwareVersion?: string;
  deviceOnlineStatus?: boolean;
  lastSeen?: string;
  appName?: string;
  appId?: number;
  idOfAppVersion?: number;
  sdCardCmSerialId?: string;
  deviceCmSerialId?: string;
}

export interface WebModelGetLicenseCounts {
  myLicensesCount?: number;
  companyLicensesCount?: number;
  memberLicensesCount?: number;
}

export interface WebModelGetAddress {
  /** The Id of the address */
  id: number;
  /** The iso6339_alpha2 country code of the address */
  country: string;
  /** The state of the address */
  state?: string;
  /** The city of the address */
  city: string;
  /** The postal code of the address */
  postalCode: string;
  /** The street of the address */
  street: string;
  /** The house number of the address */
  houseNumber?: string;
  /** Additional address info */
  additionalInfo?: string;
}

export interface WebModelDeleteRemoveDeviceFromAccount {
  device?: WebModelGetDevice;
  owner?: WebModelGetUser;
  company?: WebModelGetCompany;
  deletedDeviceFromAccount?: boolean;
  licensesWithErrors?: WebModelGetLicense[];
}

export type RemoveFromCompanyParams = {
uuid: string;
'company-id': string;
};

export type UpdateInvoiceTemplateForHubBody = {
  file: Blob;
};

export type UpdateCreditNoteTemplateForHubBody = {
  file: Blob;
};

export type FindDevicesParams = {
'user-uuid'?: string;
companyId?: string;
public?: boolean;
};

export type UpdateDeviceBody = {
  /** The icon image file */
  iconFile?: Blob;
  json: WebModelPutUpdateDevice;
};

export type AddDeviceBody = {
  /** The icon image file */
  iconFile?: Blob;
  json: WebModelPostNewDevice;
};

export type FindCompanyProfileByCompanyParams = {
'company-id': string;
};

export type UpdateCompanyProfileBody = {
  /** The icon image file */
  iconFile?: Blob;
  /** The banner image file */
  bannerFile?: Blob;
  /** The privacy policy file */
  privacyPolicyFile?: Blob;
  json: WebModelPutUpdateCompanyProfile;
};

export type UpdateVersionDataBody = {
  json: WebModelPutAppVersionData;
  changelogFile?: Blob;
  pictureVideoUsecaseFiles?: Blob[];
  technicalDocumentationFiles?: Blob[];
};

export type UpdateCoreDataBody = {
  json: WebModelPutAppCoreData;
  /** The icon image file */
  file?: Blob;
};

export type ConfirmOfflineUpdateFileDownloadParams = {
cmSerial: string;
};

export type ConfirmOfflineRarRequestedParams = {
cmSerial: string;
};

export type ConfirmOfflineProcessParams = {
'license-id': number;
cmSerial: string;
jsonFile: boolean;
};

export type ConfirmOfflineProcessAfterwardsParams = {
deviceid: string;
ticketid: string;
cmserial: string;
jsonFile: boolean;
};

export type CreateCertificateParams = {
totp: string;
};

export type CreateCertificateBody = {
  csrFile: Blob;
};

export type GetMfaRecoveryCodeInfoParams = {
code: string;
};

export type IssueMfaRecoveryCodeParams = {
code: string;
};

export type AddRoleParams = {
'user-uuid': string;
};

export type RemoveRoleParams = {
'user-uuid': string;
};

export type RegisterPayment200 = {[key: string]: string};

export type FindPaymentAccountsByCompanyParams = {
'company-id': string;
};

export type CreatePaymentAccountParams = {
'hub-name': string;
'company-id': string;
};

export type SendSupportMessageBody = {
  json: WebModelPostSupportMessage;
  /** Uploaded files */
  files?: Blob[];
};

export type UploadStoreFileToSetContainerIdBody = {
  racFile: Blob;
};

export type GetDeviceStatusParams = {
'device-id': string;
'user-uuid': string;
};

export type AddAppBinaryBody = {
  json: WebModelPostAppBinary;
  appFile: Blob;
};

export type GetAppUsersParams = {
appId: number;
};

export type AddAppUsersParams = {
appId: number;
};

export type DeleteAppUsersParams = {
appId: number;
};

export type AddAppToDeveloperFavoritesParams = {
appId: number;
userId: string;
};

export type DeleteAppFromDeveloperFavoritesParams = {
appId: number;
userId: string;
};

export type GetUserRefreshTaskStatus200 = typeof GetUserRefreshTaskStatus200[keyof typeof GetUserRefreshTaskStatus200];


export const GetUserRefreshTaskStatus200 = {
  ACTIVE: 'ACTIVE',
  READY: 'READY',
  EXPIRED: 'EXPIRED',
  SUCCEEDED: 'SUCCEEDED',
  SUSPENDED: 'SUSPENDED',
  FILTERED: 'FILTERED',
  FAILED: 'FAILED',
  RECREATED: 'RECREATED',
  REDUNDANT: 'REDUNDANT',
} as const;

export type AuthorizeReactivationParams = {
id: string;
};

export type ImportLicensesViaLicenseOrderXmlFileParams = {
importForCompany?: boolean;
};

export type ActivateOfflineLicenseParams = {
'device-id': string;
cmSerial: string;
jsonFile: boolean;
licenseIds: number[];
};

export type FindUsersByRoleParams = {
'role-name'?: string;
};

export type GetUserStatusParams = {
uuid: string;
};

export type GetUserStatus200Item = typeof GetUserStatus200Item[keyof typeof GetUserStatus200Item];


export const GetUserStatus200Item = {
  USER_DATA: 'USER_DATA',
  COMPANY_DATA: 'COMPANY_DATA',
  COMPANY_PROFILE: 'COMPANY_PROFILE',
  DEVELOPER_REQUEST: 'DEVELOPER_REQUEST',
  NO_APP_PUBLISHED: 'NO_APP_PUBLISHED',
  COMPANY_INVITATION: 'COMPANY_INVITATION',
  USER_MFA_REQUIRED: 'USER_MFA_REQUIRED',
} as const;

export type FindPublicCompanyUsersParams = {
'company-id': string;
};

export type JwtTokenInfo200 = { [key: string]: unknown };

export type FindUserByIdentifierParams = {
userNameOrEmailOrUuid: string;
};

export type FindHubForUserParams = {
uuid?: string;
};

export type FindUserRolesParams = {
'user-uuid': string;
};

export type GetRequstedActionsParams = {
completed?: boolean;
};

export type ExportPaymentsCsvParams = {
from: string;
to: string;
};

export type ExportPaymentsCsv200 = { [key: string]: unknown };

export type GetNovalnetErrorCodeTranslationParams = {
errorCode: string;
};

export type FindOrdersParams = {
'hub-name': string;
};

export type ExportKPIsAsWebModelParams = {
from: string;
to: string;
};

export type ExportKPIsAsCsvParams = {
from: string;
to: string;
};

export type GetAllKnowlegdebaseDocumentsParams = {
filter: string;
};

export type GetJournalsParams = {
search?: string;
/**
 * @minimum 0
 */
offset?: number;
/**
 * @minimum 0
 * @maximum 2147483647
 */
limit?: number;
sort?: string;
filter?: GetJournalsFilterItem[];
};

export type GetJournalsFilterItem = typeof GetJournalsFilterItem[keyof typeof GetJournalsFilterItem];


export const GetJournalsFilterItem = {
  USER_LOGGED_IN: 'USER_LOGGED_IN',
  USER_REGISTERED: 'USER_REGISTERED',
  COMPANY_CREATED: 'COMPANY_CREATED',
  COMPANY_DELETED: 'COMPANY_DELETED',
  COMPANY_MEMBER_JOINED: 'COMPANY_MEMBER_JOINED',
  COMPANY_MEMBER_REMOVED: 'COMPANY_MEMBER_REMOVED',
  COMPANY_MEMBER_ROLE_CHANGED: 'COMPANY_MEMBER_ROLE_CHANGED',
  APP_CREATED: 'APP_CREATED',
  APP_DELETED: 'APP_DELETED',
  APP_STATUS_UPDATED: 'APP_STATUS_UPDATED',
  APP_VERSION_CREATED: 'APP_VERSION_CREATED',
  APP_VERSION_DELETED: 'APP_VERSION_DELETED',
  LICENSE_IMPORTED: 'LICENSE_IMPORTED',
  PAYMENT_STARTED: 'PAYMENT_STARTED',
  PAYMENT_COMPLETED: 'PAYMENT_COMPLETED',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  LICENSE_IN_USE: 'LICENSE_IN_USE',
  LICENSE_ONLINE_INSTALL_STARTED: 'LICENSE_ONLINE_INSTALL_STARTED',
  LICENSE_ONLINE_INSTALL_COMPLETED: 'LICENSE_ONLINE_INSTALL_COMPLETED',
  LICENSE_UNINSTALL_COMPLETED: 'LICENSE_UNINSTALL_COMPLETED',
  LICENSE_UNINSTALL_STARTED: 'LICENSE_UNINSTALL_STARTED',
  LICENSE_MOVED: 'LICENSE_MOVED',
  LICENSE_OFFLINE_INSTALL_STARTED: 'LICENSE_OFFLINE_INSTALL_STARTED',
  LICENSE_OFFLINE_OPERATION_COMPLETED: 'LICENSE_OFFLINE_OPERATION_COMPLETED',
  LICENSE_OFFLINE_UNINSTALL_STARTED: 'LICENSE_OFFLINE_UNINSTALL_STARTED',
  DEVICE_MOVED: 'DEVICE_MOVED',
  APP_INSTALLATION_STARTED: 'APP_INSTALLATION_STARTED',
  APP_INSTALLATION_FOUND: 'APP_INSTALLATION_FOUND',
  APP_UPDATE_STARTED: 'APP_UPDATE_STARTED',
  APP_UNINSTALL_STARTED: 'APP_UNINSTALL_STARTED',
  DEVICE_ADDED: 'DEVICE_ADDED',
  DEVICE_REMOVED: 'DEVICE_REMOVED',
  DEVICE_UPDATED: 'DEVICE_UPDATED',
  RPC_REQUEST_SEND: 'RPC_REQUEST_SEND',
  RPC_RESULT_RECEIVED: 'RPC_RESULT_RECEIVED',
  RPC_REQUEST_TIMEOUT: 'RPC_REQUEST_TIMEOUT',
  SUBSCRIPTIONS_FOR_APP_CREATED: 'SUBSCRIPTIONS_FOR_APP_CREATED',
  SUBSCRIPTIONS_FOR_APP_DELETED: 'SUBSCRIPTIONS_FOR_APP_DELETED',
  LICENSE_LINKED_TO_HOST_DEVICE: 'LICENSE_LINKED_TO_HOST_DEVICE',
} as const;

export type GetUserJournalsParams = {
search?: string;
filter?: GetUserJournalsFilterItem[];
/**
 * @minimum 0
 */
offset?: number;
/**
 * @minimum 0
 * @maximum 2147483647
 */
limit?: number;
sort?: string;
};

export type GetUserJournalsFilterItem = typeof GetUserJournalsFilterItem[keyof typeof GetUserJournalsFilterItem];


export const GetUserJournalsFilterItem = {
  USER_LOGGED_IN: 'USER_LOGGED_IN',
  USER_REGISTERED: 'USER_REGISTERED',
  COMPANY_CREATED: 'COMPANY_CREATED',
  COMPANY_DELETED: 'COMPANY_DELETED',
  COMPANY_MEMBER_JOINED: 'COMPANY_MEMBER_JOINED',
  COMPANY_MEMBER_REMOVED: 'COMPANY_MEMBER_REMOVED',
  COMPANY_MEMBER_ROLE_CHANGED: 'COMPANY_MEMBER_ROLE_CHANGED',
  APP_CREATED: 'APP_CREATED',
  APP_DELETED: 'APP_DELETED',
  APP_STATUS_UPDATED: 'APP_STATUS_UPDATED',
  APP_VERSION_CREATED: 'APP_VERSION_CREATED',
  APP_VERSION_DELETED: 'APP_VERSION_DELETED',
  LICENSE_IMPORTED: 'LICENSE_IMPORTED',
  PAYMENT_STARTED: 'PAYMENT_STARTED',
  PAYMENT_COMPLETED: 'PAYMENT_COMPLETED',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  LICENSE_IN_USE: 'LICENSE_IN_USE',
  LICENSE_ONLINE_INSTALL_STARTED: 'LICENSE_ONLINE_INSTALL_STARTED',
  LICENSE_ONLINE_INSTALL_COMPLETED: 'LICENSE_ONLINE_INSTALL_COMPLETED',
  LICENSE_UNINSTALL_COMPLETED: 'LICENSE_UNINSTALL_COMPLETED',
  LICENSE_UNINSTALL_STARTED: 'LICENSE_UNINSTALL_STARTED',
  LICENSE_MOVED: 'LICENSE_MOVED',
  LICENSE_OFFLINE_INSTALL_STARTED: 'LICENSE_OFFLINE_INSTALL_STARTED',
  LICENSE_OFFLINE_OPERATION_COMPLETED: 'LICENSE_OFFLINE_OPERATION_COMPLETED',
  LICENSE_OFFLINE_UNINSTALL_STARTED: 'LICENSE_OFFLINE_UNINSTALL_STARTED',
  DEVICE_MOVED: 'DEVICE_MOVED',
  APP_INSTALLATION_STARTED: 'APP_INSTALLATION_STARTED',
  APP_INSTALLATION_FOUND: 'APP_INSTALLATION_FOUND',
  APP_UPDATE_STARTED: 'APP_UPDATE_STARTED',
  APP_UNINSTALL_STARTED: 'APP_UNINSTALL_STARTED',
  DEVICE_ADDED: 'DEVICE_ADDED',
  DEVICE_REMOVED: 'DEVICE_REMOVED',
  DEVICE_UPDATED: 'DEVICE_UPDATED',
  RPC_REQUEST_SEND: 'RPC_REQUEST_SEND',
  RPC_RESULT_RECEIVED: 'RPC_RESULT_RECEIVED',
  RPC_REQUEST_TIMEOUT: 'RPC_REQUEST_TIMEOUT',
  SUBSCRIPTIONS_FOR_APP_CREATED: 'SUBSCRIPTIONS_FOR_APP_CREATED',
  SUBSCRIPTIONS_FOR_APP_DELETED: 'SUBSCRIPTIONS_FOR_APP_DELETED',
  LICENSE_LINKED_TO_HOST_DEVICE: 'LICENSE_LINKED_TO_HOST_DEVICE',
} as const;

export type GetUserJournalCountParams = {
search?: string;
filter?: GetUserJournalCountFilterItem[];
};

export type GetUserJournalCountFilterItem = typeof GetUserJournalCountFilterItem[keyof typeof GetUserJournalCountFilterItem];


export const GetUserJournalCountFilterItem = {
  USER_LOGGED_IN: 'USER_LOGGED_IN',
  USER_REGISTERED: 'USER_REGISTERED',
  COMPANY_CREATED: 'COMPANY_CREATED',
  COMPANY_DELETED: 'COMPANY_DELETED',
  COMPANY_MEMBER_JOINED: 'COMPANY_MEMBER_JOINED',
  COMPANY_MEMBER_REMOVED: 'COMPANY_MEMBER_REMOVED',
  COMPANY_MEMBER_ROLE_CHANGED: 'COMPANY_MEMBER_ROLE_CHANGED',
  APP_CREATED: 'APP_CREATED',
  APP_DELETED: 'APP_DELETED',
  APP_STATUS_UPDATED: 'APP_STATUS_UPDATED',
  APP_VERSION_CREATED: 'APP_VERSION_CREATED',
  APP_VERSION_DELETED: 'APP_VERSION_DELETED',
  LICENSE_IMPORTED: 'LICENSE_IMPORTED',
  PAYMENT_STARTED: 'PAYMENT_STARTED',
  PAYMENT_COMPLETED: 'PAYMENT_COMPLETED',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  LICENSE_IN_USE: 'LICENSE_IN_USE',
  LICENSE_ONLINE_INSTALL_STARTED: 'LICENSE_ONLINE_INSTALL_STARTED',
  LICENSE_ONLINE_INSTALL_COMPLETED: 'LICENSE_ONLINE_INSTALL_COMPLETED',
  LICENSE_UNINSTALL_COMPLETED: 'LICENSE_UNINSTALL_COMPLETED',
  LICENSE_UNINSTALL_STARTED: 'LICENSE_UNINSTALL_STARTED',
  LICENSE_MOVED: 'LICENSE_MOVED',
  LICENSE_OFFLINE_INSTALL_STARTED: 'LICENSE_OFFLINE_INSTALL_STARTED',
  LICENSE_OFFLINE_OPERATION_COMPLETED: 'LICENSE_OFFLINE_OPERATION_COMPLETED',
  LICENSE_OFFLINE_UNINSTALL_STARTED: 'LICENSE_OFFLINE_UNINSTALL_STARTED',
  DEVICE_MOVED: 'DEVICE_MOVED',
  APP_INSTALLATION_STARTED: 'APP_INSTALLATION_STARTED',
  APP_INSTALLATION_FOUND: 'APP_INSTALLATION_FOUND',
  APP_UPDATE_STARTED: 'APP_UPDATE_STARTED',
  APP_UNINSTALL_STARTED: 'APP_UNINSTALL_STARTED',
  DEVICE_ADDED: 'DEVICE_ADDED',
  DEVICE_REMOVED: 'DEVICE_REMOVED',
  DEVICE_UPDATED: 'DEVICE_UPDATED',
  RPC_REQUEST_SEND: 'RPC_REQUEST_SEND',
  RPC_RESULT_RECEIVED: 'RPC_RESULT_RECEIVED',
  RPC_REQUEST_TIMEOUT: 'RPC_REQUEST_TIMEOUT',
  SUBSCRIPTIONS_FOR_APP_CREATED: 'SUBSCRIPTIONS_FOR_APP_CREATED',
  SUBSCRIPTIONS_FOR_APP_DELETED: 'SUBSCRIPTIONS_FOR_APP_DELETED',
  LICENSE_LINKED_TO_HOST_DEVICE: 'LICENSE_LINKED_TO_HOST_DEVICE',
} as const;

export type GetDeviceJournalsParams = {
search?: string;
filter?: GetDeviceJournalsFilterItem[];
/**
 * @minimum 0
 */
offset?: number;
/**
 * @minimum 0
 * @maximum 2147483647
 */
limit?: number;
sort?: string;
};

export type GetDeviceJournalsFilterItem = typeof GetDeviceJournalsFilterItem[keyof typeof GetDeviceJournalsFilterItem];


export const GetDeviceJournalsFilterItem = {
  USER_LOGGED_IN: 'USER_LOGGED_IN',
  USER_REGISTERED: 'USER_REGISTERED',
  COMPANY_CREATED: 'COMPANY_CREATED',
  COMPANY_DELETED: 'COMPANY_DELETED',
  COMPANY_MEMBER_JOINED: 'COMPANY_MEMBER_JOINED',
  COMPANY_MEMBER_REMOVED: 'COMPANY_MEMBER_REMOVED',
  COMPANY_MEMBER_ROLE_CHANGED: 'COMPANY_MEMBER_ROLE_CHANGED',
  APP_CREATED: 'APP_CREATED',
  APP_DELETED: 'APP_DELETED',
  APP_STATUS_UPDATED: 'APP_STATUS_UPDATED',
  APP_VERSION_CREATED: 'APP_VERSION_CREATED',
  APP_VERSION_DELETED: 'APP_VERSION_DELETED',
  LICENSE_IMPORTED: 'LICENSE_IMPORTED',
  PAYMENT_STARTED: 'PAYMENT_STARTED',
  PAYMENT_COMPLETED: 'PAYMENT_COMPLETED',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  LICENSE_IN_USE: 'LICENSE_IN_USE',
  LICENSE_ONLINE_INSTALL_STARTED: 'LICENSE_ONLINE_INSTALL_STARTED',
  LICENSE_ONLINE_INSTALL_COMPLETED: 'LICENSE_ONLINE_INSTALL_COMPLETED',
  LICENSE_UNINSTALL_COMPLETED: 'LICENSE_UNINSTALL_COMPLETED',
  LICENSE_UNINSTALL_STARTED: 'LICENSE_UNINSTALL_STARTED',
  LICENSE_MOVED: 'LICENSE_MOVED',
  LICENSE_OFFLINE_INSTALL_STARTED: 'LICENSE_OFFLINE_INSTALL_STARTED',
  LICENSE_OFFLINE_OPERATION_COMPLETED: 'LICENSE_OFFLINE_OPERATION_COMPLETED',
  LICENSE_OFFLINE_UNINSTALL_STARTED: 'LICENSE_OFFLINE_UNINSTALL_STARTED',
  DEVICE_MOVED: 'DEVICE_MOVED',
  APP_INSTALLATION_STARTED: 'APP_INSTALLATION_STARTED',
  APP_INSTALLATION_FOUND: 'APP_INSTALLATION_FOUND',
  APP_UPDATE_STARTED: 'APP_UPDATE_STARTED',
  APP_UNINSTALL_STARTED: 'APP_UNINSTALL_STARTED',
  DEVICE_ADDED: 'DEVICE_ADDED',
  DEVICE_REMOVED: 'DEVICE_REMOVED',
  DEVICE_UPDATED: 'DEVICE_UPDATED',
  RPC_REQUEST_SEND: 'RPC_REQUEST_SEND',
  RPC_RESULT_RECEIVED: 'RPC_RESULT_RECEIVED',
  RPC_REQUEST_TIMEOUT: 'RPC_REQUEST_TIMEOUT',
  SUBSCRIPTIONS_FOR_APP_CREATED: 'SUBSCRIPTIONS_FOR_APP_CREATED',
  SUBSCRIPTIONS_FOR_APP_DELETED: 'SUBSCRIPTIONS_FOR_APP_DELETED',
  LICENSE_LINKED_TO_HOST_DEVICE: 'LICENSE_LINKED_TO_HOST_DEVICE',
} as const;

export type GetDeviceJournalsCountParams = {
search?: string;
filter?: GetDeviceJournalsCountFilterItem[];
};

export type GetDeviceJournalsCountFilterItem = typeof GetDeviceJournalsCountFilterItem[keyof typeof GetDeviceJournalsCountFilterItem];


export const GetDeviceJournalsCountFilterItem = {
  USER_LOGGED_IN: 'USER_LOGGED_IN',
  USER_REGISTERED: 'USER_REGISTERED',
  COMPANY_CREATED: 'COMPANY_CREATED',
  COMPANY_DELETED: 'COMPANY_DELETED',
  COMPANY_MEMBER_JOINED: 'COMPANY_MEMBER_JOINED',
  COMPANY_MEMBER_REMOVED: 'COMPANY_MEMBER_REMOVED',
  COMPANY_MEMBER_ROLE_CHANGED: 'COMPANY_MEMBER_ROLE_CHANGED',
  APP_CREATED: 'APP_CREATED',
  APP_DELETED: 'APP_DELETED',
  APP_STATUS_UPDATED: 'APP_STATUS_UPDATED',
  APP_VERSION_CREATED: 'APP_VERSION_CREATED',
  APP_VERSION_DELETED: 'APP_VERSION_DELETED',
  LICENSE_IMPORTED: 'LICENSE_IMPORTED',
  PAYMENT_STARTED: 'PAYMENT_STARTED',
  PAYMENT_COMPLETED: 'PAYMENT_COMPLETED',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  LICENSE_IN_USE: 'LICENSE_IN_USE',
  LICENSE_ONLINE_INSTALL_STARTED: 'LICENSE_ONLINE_INSTALL_STARTED',
  LICENSE_ONLINE_INSTALL_COMPLETED: 'LICENSE_ONLINE_INSTALL_COMPLETED',
  LICENSE_UNINSTALL_COMPLETED: 'LICENSE_UNINSTALL_COMPLETED',
  LICENSE_UNINSTALL_STARTED: 'LICENSE_UNINSTALL_STARTED',
  LICENSE_MOVED: 'LICENSE_MOVED',
  LICENSE_OFFLINE_INSTALL_STARTED: 'LICENSE_OFFLINE_INSTALL_STARTED',
  LICENSE_OFFLINE_OPERATION_COMPLETED: 'LICENSE_OFFLINE_OPERATION_COMPLETED',
  LICENSE_OFFLINE_UNINSTALL_STARTED: 'LICENSE_OFFLINE_UNINSTALL_STARTED',
  DEVICE_MOVED: 'DEVICE_MOVED',
  APP_INSTALLATION_STARTED: 'APP_INSTALLATION_STARTED',
  APP_INSTALLATION_FOUND: 'APP_INSTALLATION_FOUND',
  APP_UPDATE_STARTED: 'APP_UPDATE_STARTED',
  APP_UNINSTALL_STARTED: 'APP_UNINSTALL_STARTED',
  DEVICE_ADDED: 'DEVICE_ADDED',
  DEVICE_REMOVED: 'DEVICE_REMOVED',
  DEVICE_UPDATED: 'DEVICE_UPDATED',
  RPC_REQUEST_SEND: 'RPC_REQUEST_SEND',
  RPC_RESULT_RECEIVED: 'RPC_RESULT_RECEIVED',
  RPC_REQUEST_TIMEOUT: 'RPC_REQUEST_TIMEOUT',
  SUBSCRIPTIONS_FOR_APP_CREATED: 'SUBSCRIPTIONS_FOR_APP_CREATED',
  SUBSCRIPTIONS_FOR_APP_DELETED: 'SUBSCRIPTIONS_FOR_APP_DELETED',
  LICENSE_LINKED_TO_HOST_DEVICE: 'LICENSE_LINKED_TO_HOST_DEVICE',
} as const;

export type GetJournalsCountParams = {
search?: string;
filter?: GetJournalsCountFilterItem[];
};

export type GetJournalsCountFilterItem = typeof GetJournalsCountFilterItem[keyof typeof GetJournalsCountFilterItem];


export const GetJournalsCountFilterItem = {
  USER_LOGGED_IN: 'USER_LOGGED_IN',
  USER_REGISTERED: 'USER_REGISTERED',
  COMPANY_CREATED: 'COMPANY_CREATED',
  COMPANY_DELETED: 'COMPANY_DELETED',
  COMPANY_MEMBER_JOINED: 'COMPANY_MEMBER_JOINED',
  COMPANY_MEMBER_REMOVED: 'COMPANY_MEMBER_REMOVED',
  COMPANY_MEMBER_ROLE_CHANGED: 'COMPANY_MEMBER_ROLE_CHANGED',
  APP_CREATED: 'APP_CREATED',
  APP_DELETED: 'APP_DELETED',
  APP_STATUS_UPDATED: 'APP_STATUS_UPDATED',
  APP_VERSION_CREATED: 'APP_VERSION_CREATED',
  APP_VERSION_DELETED: 'APP_VERSION_DELETED',
  LICENSE_IMPORTED: 'LICENSE_IMPORTED',
  PAYMENT_STARTED: 'PAYMENT_STARTED',
  PAYMENT_COMPLETED: 'PAYMENT_COMPLETED',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  LICENSE_IN_USE: 'LICENSE_IN_USE',
  LICENSE_ONLINE_INSTALL_STARTED: 'LICENSE_ONLINE_INSTALL_STARTED',
  LICENSE_ONLINE_INSTALL_COMPLETED: 'LICENSE_ONLINE_INSTALL_COMPLETED',
  LICENSE_UNINSTALL_COMPLETED: 'LICENSE_UNINSTALL_COMPLETED',
  LICENSE_UNINSTALL_STARTED: 'LICENSE_UNINSTALL_STARTED',
  LICENSE_MOVED: 'LICENSE_MOVED',
  LICENSE_OFFLINE_INSTALL_STARTED: 'LICENSE_OFFLINE_INSTALL_STARTED',
  LICENSE_OFFLINE_OPERATION_COMPLETED: 'LICENSE_OFFLINE_OPERATION_COMPLETED',
  LICENSE_OFFLINE_UNINSTALL_STARTED: 'LICENSE_OFFLINE_UNINSTALL_STARTED',
  DEVICE_MOVED: 'DEVICE_MOVED',
  APP_INSTALLATION_STARTED: 'APP_INSTALLATION_STARTED',
  APP_INSTALLATION_FOUND: 'APP_INSTALLATION_FOUND',
  APP_UPDATE_STARTED: 'APP_UPDATE_STARTED',
  APP_UNINSTALL_STARTED: 'APP_UNINSTALL_STARTED',
  DEVICE_ADDED: 'DEVICE_ADDED',
  DEVICE_REMOVED: 'DEVICE_REMOVED',
  DEVICE_UPDATED: 'DEVICE_UPDATED',
  RPC_REQUEST_SEND: 'RPC_REQUEST_SEND',
  RPC_RESULT_RECEIVED: 'RPC_RESULT_RECEIVED',
  RPC_REQUEST_TIMEOUT: 'RPC_REQUEST_TIMEOUT',
  SUBSCRIPTIONS_FOR_APP_CREATED: 'SUBSCRIPTIONS_FOR_APP_CREATED',
  SUBSCRIPTIONS_FOR_APP_DELETED: 'SUBSCRIPTIONS_FOR_APP_DELETED',
  LICENSE_LINKED_TO_HOST_DEVICE: 'LICENSE_LINKED_TO_HOST_DEVICE',
} as const;

export type GetCompanyJournalsParams = {
search?: string;
filter?: GetCompanyJournalsFilterItem[];
/**
 * @minimum 0
 */
offset?: number;
/**
 * @minimum 0
 * @maximum 2147483647
 */
limit?: number;
sort?: string;
};

export type GetCompanyJournalsFilterItem = typeof GetCompanyJournalsFilterItem[keyof typeof GetCompanyJournalsFilterItem];


export const GetCompanyJournalsFilterItem = {
  USER_LOGGED_IN: 'USER_LOGGED_IN',
  USER_REGISTERED: 'USER_REGISTERED',
  COMPANY_CREATED: 'COMPANY_CREATED',
  COMPANY_DELETED: 'COMPANY_DELETED',
  COMPANY_MEMBER_JOINED: 'COMPANY_MEMBER_JOINED',
  COMPANY_MEMBER_REMOVED: 'COMPANY_MEMBER_REMOVED',
  COMPANY_MEMBER_ROLE_CHANGED: 'COMPANY_MEMBER_ROLE_CHANGED',
  APP_CREATED: 'APP_CREATED',
  APP_DELETED: 'APP_DELETED',
  APP_STATUS_UPDATED: 'APP_STATUS_UPDATED',
  APP_VERSION_CREATED: 'APP_VERSION_CREATED',
  APP_VERSION_DELETED: 'APP_VERSION_DELETED',
  LICENSE_IMPORTED: 'LICENSE_IMPORTED',
  PAYMENT_STARTED: 'PAYMENT_STARTED',
  PAYMENT_COMPLETED: 'PAYMENT_COMPLETED',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  LICENSE_IN_USE: 'LICENSE_IN_USE',
  LICENSE_ONLINE_INSTALL_STARTED: 'LICENSE_ONLINE_INSTALL_STARTED',
  LICENSE_ONLINE_INSTALL_COMPLETED: 'LICENSE_ONLINE_INSTALL_COMPLETED',
  LICENSE_UNINSTALL_COMPLETED: 'LICENSE_UNINSTALL_COMPLETED',
  LICENSE_UNINSTALL_STARTED: 'LICENSE_UNINSTALL_STARTED',
  LICENSE_MOVED: 'LICENSE_MOVED',
  LICENSE_OFFLINE_INSTALL_STARTED: 'LICENSE_OFFLINE_INSTALL_STARTED',
  LICENSE_OFFLINE_OPERATION_COMPLETED: 'LICENSE_OFFLINE_OPERATION_COMPLETED',
  LICENSE_OFFLINE_UNINSTALL_STARTED: 'LICENSE_OFFLINE_UNINSTALL_STARTED',
  DEVICE_MOVED: 'DEVICE_MOVED',
  APP_INSTALLATION_STARTED: 'APP_INSTALLATION_STARTED',
  APP_INSTALLATION_FOUND: 'APP_INSTALLATION_FOUND',
  APP_UPDATE_STARTED: 'APP_UPDATE_STARTED',
  APP_UNINSTALL_STARTED: 'APP_UNINSTALL_STARTED',
  DEVICE_ADDED: 'DEVICE_ADDED',
  DEVICE_REMOVED: 'DEVICE_REMOVED',
  DEVICE_UPDATED: 'DEVICE_UPDATED',
  RPC_REQUEST_SEND: 'RPC_REQUEST_SEND',
  RPC_RESULT_RECEIVED: 'RPC_RESULT_RECEIVED',
  RPC_REQUEST_TIMEOUT: 'RPC_REQUEST_TIMEOUT',
  SUBSCRIPTIONS_FOR_APP_CREATED: 'SUBSCRIPTIONS_FOR_APP_CREATED',
  SUBSCRIPTIONS_FOR_APP_DELETED: 'SUBSCRIPTIONS_FOR_APP_DELETED',
  LICENSE_LINKED_TO_HOST_DEVICE: 'LICENSE_LINKED_TO_HOST_DEVICE',
} as const;

export type GetCompanyJournalCountParams = {
search?: string;
filter?: GetCompanyJournalCountFilterItem[];
};

export type GetCompanyJournalCountFilterItem = typeof GetCompanyJournalCountFilterItem[keyof typeof GetCompanyJournalCountFilterItem];


export const GetCompanyJournalCountFilterItem = {
  USER_LOGGED_IN: 'USER_LOGGED_IN',
  USER_REGISTERED: 'USER_REGISTERED',
  COMPANY_CREATED: 'COMPANY_CREATED',
  COMPANY_DELETED: 'COMPANY_DELETED',
  COMPANY_MEMBER_JOINED: 'COMPANY_MEMBER_JOINED',
  COMPANY_MEMBER_REMOVED: 'COMPANY_MEMBER_REMOVED',
  COMPANY_MEMBER_ROLE_CHANGED: 'COMPANY_MEMBER_ROLE_CHANGED',
  APP_CREATED: 'APP_CREATED',
  APP_DELETED: 'APP_DELETED',
  APP_STATUS_UPDATED: 'APP_STATUS_UPDATED',
  APP_VERSION_CREATED: 'APP_VERSION_CREATED',
  APP_VERSION_DELETED: 'APP_VERSION_DELETED',
  LICENSE_IMPORTED: 'LICENSE_IMPORTED',
  PAYMENT_STARTED: 'PAYMENT_STARTED',
  PAYMENT_COMPLETED: 'PAYMENT_COMPLETED',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  LICENSE_IN_USE: 'LICENSE_IN_USE',
  LICENSE_ONLINE_INSTALL_STARTED: 'LICENSE_ONLINE_INSTALL_STARTED',
  LICENSE_ONLINE_INSTALL_COMPLETED: 'LICENSE_ONLINE_INSTALL_COMPLETED',
  LICENSE_UNINSTALL_COMPLETED: 'LICENSE_UNINSTALL_COMPLETED',
  LICENSE_UNINSTALL_STARTED: 'LICENSE_UNINSTALL_STARTED',
  LICENSE_MOVED: 'LICENSE_MOVED',
  LICENSE_OFFLINE_INSTALL_STARTED: 'LICENSE_OFFLINE_INSTALL_STARTED',
  LICENSE_OFFLINE_OPERATION_COMPLETED: 'LICENSE_OFFLINE_OPERATION_COMPLETED',
  LICENSE_OFFLINE_UNINSTALL_STARTED: 'LICENSE_OFFLINE_UNINSTALL_STARTED',
  DEVICE_MOVED: 'DEVICE_MOVED',
  APP_INSTALLATION_STARTED: 'APP_INSTALLATION_STARTED',
  APP_INSTALLATION_FOUND: 'APP_INSTALLATION_FOUND',
  APP_UPDATE_STARTED: 'APP_UPDATE_STARTED',
  APP_UNINSTALL_STARTED: 'APP_UNINSTALL_STARTED',
  DEVICE_ADDED: 'DEVICE_ADDED',
  DEVICE_REMOVED: 'DEVICE_REMOVED',
  DEVICE_UPDATED: 'DEVICE_UPDATED',
  RPC_REQUEST_SEND: 'RPC_REQUEST_SEND',
  RPC_RESULT_RECEIVED: 'RPC_RESULT_RECEIVED',
  RPC_REQUEST_TIMEOUT: 'RPC_REQUEST_TIMEOUT',
  SUBSCRIPTIONS_FOR_APP_CREATED: 'SUBSCRIPTIONS_FOR_APP_CREATED',
  SUBSCRIPTIONS_FOR_APP_DELETED: 'SUBSCRIPTIONS_FOR_APP_DELETED',
  LICENSE_LINKED_TO_HOST_DEVICE: 'LICENSE_LINKED_TO_HOST_DEVICE',
} as const;

export type FindSelectableDevicesParams = {
'user-uuid': string;
'app-id'?: number;
licenseOptionIds?: number[];
/**
 * 0 = Trial, 1 = Paid (default)
 */
'license-type'?: number;
};

export type FindAllDevicesWithAppsAndLicensesParams = {
'user-uuid': string;
'device-ids'?: string[];
};

export type GetAllLicenseOptionsParams = {
include_licensebundles?: boolean;
};

export type FindAppsParams = {
/**
 * The sorting parameter. Can be one of: 'downloads' (asc)/'-downloads' (desc), price (asc), -price (desc), ...
 */
sort?: string;
'user-uuid'?: string;
hubName?: string;
name?: string;
category_ids?: number[];
/**
 * id of apptype
 */
type?: number;
/**
 * status (possible values: 0 = Draft, 1 = Released, 2 = Archived)
 */
status?: number[];
certified?: boolean;
free_apps?: boolean;
company_ids?: string[];
hardware?: string[];
};

export type FindAppByAppIdAndInternalVersionParams = {
appId: number;
internalVersion: number;
};

export type FindAppsPageParams = {
/**
 * The sorting parameter. Can be one of: 'downloads' (asc)/'-downloads' (desc), price (asc), -price (desc), ...
 */
sort?: string;
'user-uuid'?: string;
hubName?: string;
name?: string;
category_ids?: number[];
/**
 * id of apptype
 */
type?: number;
/**
 * status (possible values: 0 = Draft, 1 = Released, 2 = Archived)
 */
status?: number[];
certified?: boolean;
free_apps?: boolean;
company_ids?: string[];
hardware?: string[];
pageNumber: number;
pageSize: number;
};

export type GetAppWithHistoryParams = {
archived?: boolean;
deactivated?: boolean;
drafted?: boolean;
};

export type FindAppLicensesParams = {
'app-id'?: number;
'device-id'?: string;
'user-uuid': string;
'company-id'?: string;
'trial-license'?: boolean;
public?: boolean;
};

export type IsTrialAvailableParams = {
'app-id'?: number;
'device-id'?: string;
'user-uuid': string;
};

export type GetDetailedLicenseInstallationInformationParams = {
'app-id'?: number;
'device-id': string;
'user-uuid': string;
'container-type'?: GetDetailedLicenseInstallationInformationContainerType;
};

export type GetDetailedLicenseInstallationInformationContainerType = typeof GetDetailedLicenseInstallationInformationContainerType[keyof typeof GetDetailedLicenseInstallationInformationContainerType];


export const GetDetailedLicenseInstallationInformationContainerType = {
  DEVICE: 'DEVICE',
  SDCARD: 'SDCARD',
} as const;

export type GetDetailedAppInstallationInformationParams = {
'app-id'?: number;
'device-id': string;
'user-uuid': string;
};

export type RemoveFromAccountByAdminParams = {
force?: boolean;
};

export type UninstallLicenseParams = {
lid: number;
};

export type UninstallAppAndLicenseParams = {
'deactivate-licenses': boolean;
};

export type DeactivateOfflineLicenseParams = {
licenseIds: number[];
cmSerial: string;
jsonFile: boolean;
};

